export default {
  dateInput: {
    placeholder: "jj/mm/aaaa",
    openCalendar: "Ouvrir le calendrier",
    invalid: "Date invalide : utilisez jj/mm/aaaa",
  },
  myProfile: "Mon profil",
  billing: "Facturation",
  success: "Succès",
  error: "Erreur",
  ok: "OK",
  validationSaveFailedTitle: "Erreur de validation",
  validationSaveFailedIntro:
    "L'enregistrement n'a pas pu être enregistré pour les raisons suivantes :",
  validationSaveAnyway: "Enregistrer quand même",
  validationUnderstood: "OK",
  expenseFileMissingTitle: "Aucun Related File joint",
  expenseFileMissingText:
    "Vous enregistrez sans joindre le Related File. Voulez-vous continuer quand même ?",
  expenseFileMissingCancel: "Annuler",
  validationPendingAmountToApply: "Il vous reste un montant à appliquer",
  contactOutsideOperationTitle: "Contact hors de l'opération",
  shippingIncoherenceTitle: "Incohérences dans cette expédition",
  contactOutsideOperationText:
    "{contact} ne participe pas à {operations} : ce n'est ni le client, ni le fournisseur, ni le contact d'une dépense. Si un tiers paie ou encaisse, c'est normal ; sinon, vérifiez le contact.",
  contactOutsideOperationCancel: "Vérifier",
  contactOutsideOperationBanner:
    "Cet enregistrement est appliqué à {operations}, mais {contact} ne participe pas à cette opération (ni client, ni fournisseur, ni contact d'une dépense). Vérifiez que le contact est correct.",
  collectContactNotClientTitle: "L'encaissement ne vient pas du client",
  collectContactNotClientText:
    "{contact} n'est pas le client de {operations}. Si un tiers paie pour le client, c'est normal ; sinon, vérifiez le contact.",
  collectContactNotClientBanner:
    "Cet encaissement est appliqué à {operations}, mais {contact} n'est pas le client de cette opération. Vérifiez que le contact est correct.",
  validationForceSaveSessionTitle: "Session expirée",
  validationForceSaveSessionText:
    "Impossible d'enregistrer quand même car la session a expiré. Actualisez la page ou reconnectez-vous, puis réessayez.",
  validationForceSaveGenericText:
    "Impossible de terminer l'enregistrement forcé. Vérifiez votre connexion et réessayez.",
  routerNavLoading: "Chargement…",
  testEnvironmentBanner: "Version de test — environnement local",
  testEnvironmentBannerHosted:
    "Version de test — vous consultez une copie de test (ce n'est pas la production)",
  "systemFeaturesPermissionDeniedTitle": "Permission requise",
  "systemFeaturesPermissionDeniedText":
    "Vous n'avez pas la permission d'activer ou de désactiver les fonctionnalités du système. Demandez à un administrateur le droit « Access system features » (systemfeatures.access) sur votre rôle.",
  registerSuccessLogin: "Compte créé. Vous pouvez vous connecter.",
  registerConfirmEmailSent:
    "Nous vous avons envoyé un lien à votre adresse e-mail ({email}) pour confirmer votre compte. Si vous ne l'avez pas reçu, vérifiez vos courriers indésirables. Cliquez sur le lien pour confirmer le compte.",
  forgotPassword: "Mot de passe oublié ?",
  passwordResetEmail: "Saisissez votre e-mail et nous vous enverrons un lien pour définir un nouveau mot de passe.",
  passwordResetContinue: "Continuer",
  emailSent: "Réinitialiser le mot de passe",
  correctEmail: "Nous allons envoyer le lien de réinitialisation à {email}. Est-ce correct ?",
  sendEmail: "Envoyer l'e-mail",
  pleaseinsertemail: "Saisissez l'e-mail utilisé lors de votre inscription pour être redirigé vers votre application.",
  goToMyApp: "Aller à mon application",
  seeDemo: "Voir la démo",
  incorrectUserOrPassword: "Utilisateur ou mot de passe incorrect",
  accountconfirm: "Votre compte a été confirmé, vous pouvez vous connecter.",
  getStarted: "Commencer",
  "Search fields...": "Rechercher des champs...",
  'No fields found for "{query}"': 'Aucun champ trouve pour "{query}"',
  "Type to search records...": "Tapez pour rechercher des enregistrements...",
  "Type to search a record...": "Tapez pour rechercher un enregistrement...",

  // Register.vue (clés racine pour $t)
  name: "Nom",
  email: "E-mail",
  password: "Mot de passe",
  businessName: "Nom de l'entreprise",
  login: "Connexion",
  confirmEmailText: "Consultez votre e-mail pour confirmer le compte",
  nameAlreadyTaken: "Ce nom est déjà utilisé",
  errorCheckingRestaurantName: "Impossible de vérifier la disponibilité du nom",
  nameRequired: "Le nom est obligatoire",
  countryRequired: "Le pays est obligatoire",
  restaurantNameRequired: "Le nom de l'entreprise est obligatoire",
  emailRequired: "L'e-mail est obligatoire",
  emailInvalid: "L'e-mail n'est pas valide",
  passwordRequired: "Le mot de passe est obligatoire",
  userExists: "Un compte avec cet e-mail existe déjà",
  registerCompanyLinkPlaceholder: "Lien de votre entreprise (facultatif)",
  registerHelpBusinessUrl:
    "Nous utilisons le nom de votre entreprise dans l'URL dont vos clients ont besoin pour accéder à l'application.",
  registerHelpDedicatedDbConfirm:
    "Après confirmation de votre e-mail, une base de données dédiée est créée pour votre entreprise (même utilisateur sur cette instance et la nouvelle).",
  registerHelpDedicatedDbImmediate:
    "Une base de données dédiée pour votre entreprise est créée immédiatement (même utilisateur sur cette instance et la nouvelle).",
  registerHelpCompanyLink:
    "Indiquez le lien Instagram, Facebook ou le site web de votre entreprise pour que nous puissions vous promouvoir dans nos campagnes marketing.",
  registerHelpEmailConfirmBusiness:
    "Nous vous enverrons un e-mail avec un lien pour confirmer votre compte ; la base de données de votre entreprise est créée à la confirmation.",
  registerHelpEmailConfirmAny:
    "Nous vous enverrons un e-mail avec un lien pour confirmer votre compte ; vous ne pourrez pas vous connecter tant que vous n’aurez pas confirmé.",
  registerConfirmSpamP1:
    "Si vous ne trouvez pas l'e-mail, vérifiez les courriers indésirables. Si vous n'avez pas reçu le message avec le code, contactez-nous pour activer manuellement votre compte. Écrivez-nous à contact@gotake.it ou sur le WhatsApp du support technique, cliquez ici :",
  registerConfirmWhatsapp: "WhatsApp",

  nothingtosee: "Rien à voir ici",
  logout: "Déconnexion",

  // Tutorial translations
  tutorial: {
    // Welcome step
    welcome: {
      title: "Bienvenue dans le tutoriel ExportAI",
      description:
        "Je vais vous guider à travers toutes les fonctionnalités de l'écran de liste dynamique. Vous apprendrez à utiliser les filtres, les colonnes, les recherches et bien plus encore.",
      details: [
        "Ce tutoriel vous montrera étape par étape comment fonctionne chaque fonction",
        "Vous pouvez naviguer avec les boutons ou cliquer sur les indicateurs",
        "À la fin, vous serez capable d'utiliser tous les outils comme un expert",
      ],

      tip: "Prenez votre temps pour comprendre chaque fonctionnalité. Ne vous inquiétez pas si vous ne vous souvenez pas de tout, vous pouvez toujours revoir ce tutoriel.",
    },

    // Search step
    search: {
      title: "Recherche par mots-clés",
      description:
        "Le champ de recherche vous permet de trouver rapidement des enregistrements en tapant n'importe quel texte contenant les informations que vous recherchez.",
      details: [
        "Tapez n'importe quel mot ou phrase pour rechercher",
        "La recherche est effectuée dans tous les champs visibles",
        "Les résultats sont filtrés en temps réel",
        "Vous pouvez effacer la recherche avec le bouton X",
      ],

      tip: 'Utilisez des mots spécifiques pour obtenir des résultats plus précis. Par exemple, si vous recherchez "Jean", tous les enregistrements contenant ce nom apparaîtront.',
    },

    // Column preferences step
    columnPreferences: {
      title: "Préférences des colonnes",
      description:
        "Le bouton des colonnes vous permet de personnaliser complètement les champs que vous souhaitez voir dans votre tableau et comment les organiser.",
      details: [
        "Cliquez sur le bouton avec l'icône de colonnes pour ouvrir le sélecteur",
        "Cochez/décochez les champs pour les afficher ou les masquer",
        "Glissez-déposez pour réorganiser les colonnes",
        "Les modifications sont automatiquement enregistrées dans vos préférences",
        "Vous pouvez regrouper les champs connexes pour une meilleure organisation",
      ],

      tip: "Organisez d'abord les colonnes les plus importantes pour avoir une vue plus efficace de vos données. Les préférences sont enregistrées par utilisateur et par modèle.",
    },

    // Filter preferences step
    filterPreferences: {
      title: "Préférences des filtres",
      description:
        "Le bouton des filtres vous permet de configurer quels champs seront disponibles pour le filtrage et de personnaliser votre expérience de filtrage.",
      details: [
        "Cliquez sur le bouton avec l'icône de filtre pour ouvrir le sélecteur",
        "Sélectionnez les champs que vous souhaitez rendre disponibles pour le filtrage",
        'Vous pouvez cocher/décocher des champs individuels ou utiliser "Tout sélectionner"',
        "Les champs sélectionnés apparaîtront comme des boutons de filtre",
        "Les préférences sont automatiquement enregistrées par utilisateur et par modèle",
      ],

      tip: "Sélectionnez uniquement les champs dont vous avez vraiment besoin pour filtrer afin de garder l'interface propre et centrée sur ce qui est important.",
    },

    // Filter usage step
    filterUsage: {
      title: "Utilisation des filtres configurés",
      description:
        "Une fois vos préférences configurées, les filtres apparaissent sous forme de boutons que vous pouvez utiliser pour affiner vos résultats.",
      details: [
        "Les filtres bleus sont appliqués et filtrent activement vos données",
        "Les filtres gris sont disponibles à utiliser en cas de besoin",
        "Cliquez sur n'importe quel filtre pour configurer ses critères spécifiques",
        'Vous pouvez développer pour voir plus d\'options avec le bouton "+ filtres"',
        "Combine plusieurs filtres pour des résultats plus précis",
      ],

      tip: "Gardez uniquement les filtres dont vous avez vraiment besoin pour éviter de compliquer votre vue des données. Les filtres peuvent être effacés individuellement ou tous à la fois.",
    },

    // Column sorting step
    columnSorting: {
      title: "Tri des colonnes",
      description:
        "Cliquez sur les en-têtes de colonnes pour trier les données par ordre croissant ou décroissant.",
      details: [
        "Cliquez sur l'en-tête pour trier par ordre croissant",
        "Cliquez à nouveau pour trier par ordre décroissant",
        "Les colonnes triables affichent une icône de flèche",
        "L'ordre actuel est maintenu jusqu'à ce que vous changiez la vue",
      ],

      tip: "Combinez le tri avec les filtres pour trouver rapidement les enregistrements les plus pertinents.",
    },

    // Individual column management step
    individualColumns: {
      title: "Gestion individuelle des colonnes",
      description:
        "Chaque colonne a des options individuelles telles que masquer, réorganiser et personnaliser.",
      details: [
        "Utilisez le bouton X sur chaque colonne pour la masquer",
        "Glissez-déposez les en-têtes pour réorganiser",
        "Les colonnes masquées peuvent être restaurées depuis le sélecteur",
        "Les modifications sont appliquées immédiatement",
      ],

      tip: "Masquez les colonnes que vous n'utilisez pas fréquemment pour avoir une vue plus propre et plus ciblée.",
    },

    // Preferences system step
    preferencesSystem: {
      title: "Système de préférences",
      description:
        "Toutes vos configurations de colonnes et de filtres sont automatiquement enregistrées et chargées à chaque fois que vous accédez au modèle.",
      details: [
        "Les préférences de colonnes sont enregistrées par utilisateur et par modèle",
        "Les préférences de filtres sont automatiquement enregistrées",
        "Lors du changement de modèle, les préférences spécifiques sont chargées",
        "Vous pouvez réinitialiser les préférences depuis le sélecteur de colonnes",
        "Les modifications sont synchronisées en temps réel",
      ],

      tip: "Vos préférences sont conservées entre les sessions, vous n'aurez donc pas à tout reconfigurer à chaque accès.",
    },

    // Report views step
    reportViews: {
      title: "Vues de rapport",
      description:
        "Accédez à différents types de rapports et de vues personnalisées pour analyser vos données.",
      details: [
        "Chaque bouton de rapport ouvre une vue différente",
        "Les rapports peuvent afficher des données groupées ou résumées",
        "Vous pouvez exporter les résultats dans différents formats",
        "Les vues sont enregistrées et toujours disponibles",
      ],

      tip: "Utilisez différentes vues de rapport pour analyser vos données sous plusieurs angles.",
    },

    // Bulk actions step
    bulkActions: {
      title: "Actions en masse",
      description:
        "Effectuez des opérations sur plusieurs enregistrements sélectionnés à la fois.",
      details: [
        'Sélectionnez des enregistrements individuels ou utilisez "Tout sélectionner"',
        "Effectuez une édition en masse des champs communs",
        "Supprimez plusieurs enregistrements à la fois",
        "Les actions en masse font gagner du temps sur les opérations répétitives",
      ],

      tip: "Les actions en masse sont parfaites pour mettre à jour les états, les catégories ou tout champ commun à plusieurs enregistrements.",
    },

    // Completion step
    completion: {
      title: "Tutoriel terminé !",
      description:
        "Félicitations ! Vous connaissez maintenant toutes les fonctionnalités principales de l'écran de liste dynamique.",
      details: [
        "Vous pouvez configurer les préférences de colonnes et de filtres",
        "Rechercher et filtrer les données efficacement",
        "Personnaliser les colonnes selon vos besoins",
        "Trier et organiser les informations",
        "Accéder aux rapports et vues spécialisés",
        "Effectuer des actions en masse si nécessaire",
      ],

      tip: "Pratiquez avec ces fonctions pour vous familiariser. N'oubliez pas que vous pouvez toujours revoir ce tutoriel depuis le menu d'aide.",
    },

    // Navigation buttons
    navigation: {
      previous: "Précédent",
      next: "Suivant",
      complete: "Terminer",
      exit: "Quitter",
    },

    // Progress
    progress: "sur",

    // Tip label
    tipLabel: "Astuce :",
  },

  // TutorialButton translations
  tutorialButton: {},

  // Duntower field translations
  AccountNumber: "Numéro de compte",
  "Additional costs": "Coûts supplémentaires",
  Address: "Adresse",
  Amount: "Montant",
  Applied: "Appliqué",
  "Applied to": "Appliqué à",
  "Auto load packing list": "Chargement automatique de la liste de colisage",
  "Autoload expenses": "Chargement automatique des dépenses",
  "Autoload invoice supplier":
    "Chargement automatique de la facture fournisseur",
  paymentOrderRequiresExpense:
    "Pour générer un ordre de paiement, vous devez d'abord créer l'invoice supplier / proforma supplier dans Expenses. Vous pouvez utiliser le bouton autoload expense.",
  "BL Number": "Numéro BL",
  Balance: "Solde",
  "Bank account": "Compte bancaire",
  "Bank account (from)": "Compte bancaire (origine)",
  "Bank account (to)": "Compte bancaire (destinataire)",
  "Bank account (from) and Bank account (to) cannot be the same":
    "Bank account (from) et Bank account (to) ne peuvent pas être le même compte",
  "Bank name": "Nom de la banque",
  "Billing Address": "Adresse de facturation",
  "Billing address": "Adresse de facturation",
  "Booking Number": "Numéro de réservation",
  "Buyer refererence": "Référence acheteur",
  Cartons: "Cartons",
  Category: "Catégorie",
  Flags: "Drapeaux",
  City: "Ville",
  Client: "Client",
  "Collect from": "Encaisser de",
  Collection: "Encaissement",
  "Collection Number": "Numéro d'encaissement",
  "Collection date": "Date d'encaissement",
  Collections: "Encaissements",
  Collects: "Encaissements",
  "Add Collection": "Ajouter un encaissement",
  Comment: "Commentaire",
  Comments: "Commentaires",
  Contact: "Contact",
  Container: "Conteneur",
  "Containers Involved": "Conteneurs impliqués",
  Country: "Pays",
  "Country of final destination": "Pays de destination finale",
  "Country of origin": "Pays d'origine",
  CountryOfOrigin: "Pays d'origine",
  "Quantity of containers": "Quantité de conteneurs",
  "Payment conditions (client)": "Conditions de paiement (client)",
  Finance: "Finance",
  Filters: "Filtres",
  Created: "Créé",
  "Available Balance": "Solde disponible",
  "To pay": "À payer",
  "Billing Address (client)": "Adresse de facturation (client)",
  Signature: "Signature",
  collections: "encaissements",
  expenses: "dépenses",
  "Collections List": "Liste d'encaissements",
  "Contact List": "Liste de contacts",
  "Expenses List": "Liste des dépenses",
  Collected: "Encaissé",
  Expected: "Attendu",
  Montant: "Montant",
  Export: "Export",
  Pending: "En attente",
  "shipping(s)": "expédition(s)",
  "Invoice Supplier": "Facture fournisseur",
  "To Collect": "À encaisser",
  "To apply": "À appliquer",
  "Send Payment Request": "Envoyer la demande de paiement",
  "Remove from stock": "Retirer du stock",
  "Credit note": "Note de crédit",
  "Credit notes amount": "Montant des notes de crédit",
  Currency: "Devise",
  "Currency IN": "Devise IN",
  "Currency IS": "Devise IS",
  "Currency PS": "Devise PS",
  "Customer's commercial": "Commercial du client",
  "Cut off documents": "Date limite documents",
  "Cut off physical": "Date limite physique",
  "DHL date": "Date DHL",
  "DHL number": "Numéro DHL",
  Date: "Date",
  "Date Released": "Date de libération",
  "Debit note": "Note de débit",
  "Debit notes amount": "Montant des notes de débit",
  Description: "Description",
  Documentation: "Documentation",
  "Done payments amount": "Montant des paiements effectués",
  Drafts: "Brouillons",
  Emails: "Emails",
  "Estimated time of arrival (ETA)": "Heure d'arrivée estimée (ETA)",
  "Estimated time of departure (ETD)": "Heure de départ estimée (ETD)",
  Expense: "Dépense",
  Expenses: "Dépenses",
  "Expiration of import permit": "Expiration du permis d'importation",
  "FR Comments": "Commentaires FR",
  File: "Fichier",
  Forwarder: "Transitaire",
  "Forwarding agent": "Agent de transit",
  "Gate Out": "Sortie de dépôt",
  "Gross weight": "Poids brut",
  Holder: "Titulaire",
  "IN Comments": "Commentaires IN",
  "IP applicable": "IP applicable",
  Iban: "IBAN",
  Imagen: "Image",
  "Import permit file": "Fichier du permis d'importation",
  "Import permit number": "Numéro du permis d'importation",
  "In stock": "En stock",
  Incoterm: "Incoterm",
  "Incoterm IS": "Incoterm IS",
  "Incoterm PS": "Incoterm PS",
  "Instr Comments": "Commentaires instructions",
  "Instr Consignee": "Destinataire instructions",
  "Instr Consignee in certificate":
    "Destinataire instructions dans le certificat",
  "Instr Invoice to": "Facturer à instructions",
  "Instr Labelling": "Instructions d'étiquetage",
  "Instr Notify": "Aviser instructions",
  "Instr Product": "Produit instructions",
  "Instr Shipper": "Expéditeur instructions",
  "Intermediate port": "Port intermédiaire",
  Invoice: "Facture",
  "Invoice Date": "Date de facture",
  "Invoice Number": "Numéro de facture",
  "Invoice products": "Produits de la facture",
  Language: "Langue",
  "Letter of credit": "Lettre de crédit",
  "Loading date": "Date de chargement",
  Logo: "Logo",
  "Means of Convey": "Moyen de transport",
  "Means of convey": "Moyen de transport",
  Name: "Nom",
  "Name of Vessel": "Nom du navire",
  "Net weight": "Poids net",
  Nombre: "Nom",
  Notify: "Aviser",
  Observations: "Observations",
  "Offer validity": "Validité de l'offre",
  "Original documents": "Documents originaux",
  "PF Number": "Numéro PF",
  "PL Comments": "Commentaires PL",
  "Packing List": "Liste de colisage",
  Paid: "Payé",
  "Not paid yet": "Pas encore payé",
  "Unpaid payment excluded hint":
    "Non inclus dans le solde ni les totaux tant que le paiement n'est pas marqué payé.",
  "Excluded from totals hint":
    "Non inclus dans le solde ni les totaux (ex. paiement non payé ou encaissement non reçu).",
  "Filtered by proforma": "Filtré par proforma",
  "No proforma linked for account statement":
    "Aucune proforma n'est liée à cet enregistrement : impossible de filtrer le relevé.",
  "Payment conditions": "Conditions de paiement",
  "Payment date": "Date de paiement",
  "Payment supplier": "Paiement fournisseur",
  "Payment to": "Paiement à",
  Payments: "Paiements",
  "Pending payments amount": "Montant des paiements en attente",
  Phone: "Téléphone",
  "Port Of Delivery": "Port de livraison",
  "Port Of Origin": "Port d'origine",
  "Port of delivery": "Port de livraison",
  "Port of incoterm": "Port d'incoterm",
  "Port of incoterm IS": "Port d'incoterm IS",
  "Port of incoterm PS": "Port d'incoterm PS",
  "Port of origin": "Port d'origine",
  "Postal code": "Code postal",
  Price: "Prix",
  Product: "Produit",
  submittedby: "Soumis par {name} le {date}",
  updatedby: "Mis à jour par {name} le {date}",
  Payment: "Paiement",
  "Add Payment": "Ajouter un paiement",
  "Add Expense": "Ajouter une dépense",
  Collect: "Encaissement",
  Negotiation: "Négociation",
  Settings: "Paramètres",
  Dashboard: "Tableau de bord",
  "Product and price": "Produit et prix",
  Products: "Produits",
  Contracts: "Contrats",
  Proform: "Proforma",
  "Proform file": "Fichier Proforma",
  "Proform number": "Numéro Proforma",
  "Proform number Date": "Date du numéro Proforma",
  "Qty containers": "Quantité de conteneurs",
  "Qty of Cont": "Quantité de conteneurs",
  "Quantity of Containers": "Quantité de conteneurs",
  "Raw Weight": "Poids brut",
  "Reference number": "Numéro de référence",
  ReferenceNumber: "Numéro de référence",
  "Related file": "Fichier associé",
  "Release Method": "Méthode de libération",
  "Release method": "Méthode de libération",
  Remaining: "Restant",
  "Request Date of Payment": "Date de demande de paiement",
  "Seal Number": "Numéro de scellé",
  "Shipper's commercial": "Commercial de l'expéditeur",
  Shipping: "Expédition",
  "Shipping Line": "Ligne maritime",
  ShippingLine: "Ligne maritime",
  Signature: "Signature",
  "Sizing ref": "Référence de dimensionnement",
  Status: "Statut",
  Supplier: "Fournisseur",
  "Supplier Invoice number": "Numéro de facture fournisseur",
  "Supplier invoice date": "Date de facture fournisseur",
  "Supplier products": "Produits fournisseur",
  Swift: "SWIFT",
  Title: "Titre",
  "To apply": "À appliquer",
  Total: "Total",
  "Total (USD)": "Total (USD)",
  "Total Additional Cost": "Coût supplémentaire total",
  "Total Net Weight": "Poids net total",
  "Total Price": "Prix total",
  "Total Price Cont.": "Prix total cont.",
  "Total Products and price": "Total produits et prix",
  "Total Qty Cont.": "Quantité totale cont.",
  "Total Qty.": "Quantité totale",
  "Total Qty. Cont.": "Quantité totale cont.",
  "Total Quantity": "Quantité totale",
  "Total Raw Weight": "Poids brut total",
  "Total add cost": "Coût supplémentaire total",
  "Total amount invoiced": "Montant total facturé",
  "Total billed": "Total facturé",
  "Total containers": "Total conteneurs",
  "Total credit note": "Total note de crédit",
  "Total debit note": "Total note de débit",
  "Total expenses": "Total dépenses",
  "Total invoice supplier": "Total facture fournisseur",
  "Total net weight": "Poids net total",
  "Total product price": "Prix total des produits",
  "Total proform": "Total Proforma",
  "Total qty": "Quantité totale",
  "Total quantity": "Quantité totale",
  TransitTime: "Temps de transit",
  "Transit days": "Jours de transit",
  Type: "Type",
  "Type of Cont": "Type de conteneur",
  "Type of cont": "Type de conteneur",
  "Type of container": "Type de conteneur",
  "Type of document": "Type de document",
  TypeOfContainer: "Type de conteneur",
  "Unit price": "Prix unitaire",
  "Unit qty": "Quantité unitaire",
  "Validation date": "Date de validation",
  Website: "Site web",

  shipping: "Expédition",

  "unit price": "Prix unitaire",
  "unit qty": "Quantité unitaire",
  "Credit/Debit notes": "Notes de crédit/débit",
  Documents: "Documents",
  Expenses: "Dépenses",
  Finance: "Finance",
  "Financial Overview": "Aperçu Financier",
  "Credit Notes": "Notes de crédit",
  "Debit Notes": "Notes de débit",
  "Credit Notes Analysis": "Analyse des notes de crédit",
  "Debit Notes Analysis": "Analyse des notes de débit",
  "credit notes": "notes de crédit",
  "debit notes": "notes de débit",
  "No credit notes to display": "Aucune note de crédit à afficher",
  "No debit notes to display": "Aucune note de débit à afficher",
  "Income - Expenses - Credit Notes + Debit Notes":
    "Revenus - Dépenses - Notes de crédit + Notes de débit",
  "Original Amount": "Montant original",
  "Expected Amount": "Montant attendu",
  "Credit Notes": "Notes de crédit",
  "Debit Notes": "Notes de débit",
  Adjusted: "Ajusté",
  Freight: "Fret",
  General: "Général",
  "Import Permit": "Permis d'importation",
  "Invoice (IN)": "Facture (IN)",
  "Invoice Supplier (IS)": "Facture fournisseur (IS)",
  Location: "Emplacement",
  "Packing List (PL)": "Liste de colisage (PL)",
  "Proform Shipper": "Proforma expéditeur",
  "Proform Supplier (PS)": "Proforma fournisseur (PS)",
  Proforma: "Proforma",
  "Shipping Instructions": "Instructions d'expédition",
  Shippings: "Expéditions",
  Totals: "Totaux",

  // Auto-save translations
  unsavedChanges: "Modifications non enregistrées",
  unsavedChangesMessage:
    "Vous avez des modifications en attente qui n'ont pas été enregistrées",
  savingIn: "Enregistrement dans",
  saving: "Enregistrement",
  disableAutoSave: "Désactiver l'enregistrement automatique",

  // Calendar translations
  calendar: {
    weekDays: {
      sunday: "Dim",
      monday: "Lun",
      tuesday: "Mar",
      wednesday: "Mer",
      thursday: "Jeu",
      friday: "Ven",
      saturday: "Sam",
    },
    todayEvents: {},
  },

  // Events Analyzer translations
  eventsAnalyzer: {
    today: {
      title: "Événements d'aujourd'hui",
      noEvents: "Aucun événement pour aujourd'hui",
      criteria:
        "Événements se produisant exactement aujourd'hui : chargements, paiements, encaissements, ETA, Gate Out, etc.",
    },
    thisWeek: {
      title: "Cette semaine",
      noEvents: "Aucun événement cette semaine",
      criteria:
        "Événements dans les 7 prochains jours : toutes les dates importantes qui expirent cette semaine",
    },
    nextEvents: {
      title: "Prochains événements",
      noEvents: "Aucun événement à venir",
      criteria:
        "Événements dans les 30 prochains jours (excluant cette semaine) : planification à moyen terme",
    },
    urgent: {
      title: "Événements urgents",
      noEvents: "Aucun événement urgent",
      criteria:
        "Événements nécessitant une action immédiate : ETA à venir (3 jours), paiements en retard impayés, ETA/Gate Out en retard incomplets (statut ≠ 6)",
    },
    criteria: {
      title: "Critères de classification",
      close: "Fermer",
    },
    pendingPayment: "Paiement en attente",
    viewDetails: "Voir les détails",
  },

  // Operations Summary translations
  operationsSummary: {
    title: "Résumé des opérations",
    noOperations: "Aucune opération à venir",
    help: "Aide sur les dates d'exportation",
    close: "Fermer",
    helpText: {
      title: "Critères de classification",
      sections: {
        mainDates: {
          title: "Dates principales d'expédition",
          eta: "ETA (Estimated Time of Arrival) : Date d'arrivée estimée du navire/avion au port de destination. Important pour coordonner le dédouanement et la récupération de la cargaison.",
          etd: "ETD (Estimated Time of Departure) : Date de départ estimée du navire/avion depuis le port d'origine. Marque le début du transit international.",
        },
        cutOffs: {
          title: "Dates limites",
          documents:
            "Cut Off Documents : Date limite pour présenter la documentation d'exportation. Si elle n'est pas respectée, l'expédition peut être exclue du voyage.",
          physical:
            "Cut Off Physical : Date limite pour livrer physiquement la cargaison au terminal. Après ce point, le conteneur ne peut plus être accepté.",
        },
        cargoMovements: {
          title: "Mouvements de cargaison",
          loading:
            "Date de chargement : Jour où la cargaison est chargée sur le navire/avion. Coïncide avec les opérations de manutention au port.",
          gateOut:
            "Gate Out : Date à laquelle le conteneur quitte le dépôt pour le terminal portuaire. Marque le début de la garde par le transporteur.",
        },
        documentation: {
          title: "Documentation commerciale",
          dateReleased:
            "Date de libération : Date à laquelle les documents d'expédition sont libérés. À partir de là, l'importateur peut gérer la récupération à destination.",
        },
        importPermits: {
          title: "Permis d'importation",
          expiration:
            "Expiration du permis d'importation : Date d'expiration du permis. S'il expire avant l'arrivée de la cargaison, elle ne peut pas être nationalisée.",
        },
        payments: {
          title: "Dates de paiement",
          paymentDate:
            "Date de paiement : Date à laquelle quelque chose doit être payé. Critique pour maintenir la trésorerie et éviter les pénalités.",
        },
      },
    },
    messages: {
      eta: {
        today:
          "🚢 <strong>Arrivée aujourd'hui !</strong> {count} {vessel} {verb} aujourd'hui au port de destination. Il est temps de coordonner le dédouanement et la récupération de la cargaison.",
        tomorrow:
          "🚢 <strong>Arrivée demain :</strong> {count} {vessel} {verb} demain. Préparez-vous pour le dédouanement.",
        thisWeek:
          "🚢 <strong>Cette semaine :</strong> {count} {vessel} {verb} cette semaine. Coordonnez avec l'importateur pour la récupération.",
      },
      etd: {
        today:
          "⚓ <strong>Départ aujourd'hui :</strong> {count} {vessel} {verb} aujourd'hui depuis le port d'origine. Le transit international a commencé.",
        tomorrow:
          "⚓ <strong>Départ demain :</strong> {count} {vessel} {verb} demain. Dernière chance pour compléter la documentation.",
        thisWeek:
          "⚓ <strong>Cette semaine :</strong> {count} {vessel} {verb} cette semaine depuis le port d'origine.",
      },
      loading: {
        today:
          "📦 <strong>Chargement aujourd'hui :</strong> {count} {container} {verb} aujourd'hui sur le navire. Opérations de manutention au port.",
        tomorrow:
          "📦 <strong>Chargement demain :</strong> {count} {container} {verb} demain.",
        thisWeek:
          "📦 <strong>Cette semaine :</strong> {count} {container} {verb} cette semaine.",
      },
      gateOut: {
        today:
          "🚛 <strong>Gate Out aujourd'hui :</strong> {count} {container} {verb} aujourd'hui du dépôt au terminal portuaire.",
        tomorrow:
          "🚛 <strong>Gate Out demain :</strong> {count} {container} {verb} demain vers le port.",
        thisWeek:
          "🚛 <strong>Cette semaine :</strong> {count} {container} {verb} cette semaine vers le terminal.",
      },
      payment: {
        today:
          "💰 <strong>Paiement aujourd'hui :</strong> {count} {payment} {verb} aujourd'hui. Attention ! Vérifiez le statut des paiements en attente.",
        tomorrow:
          "💰 <strong>Paiement demain :</strong> {count} {payment} {verb} demain. Préparez-vous à effectuer les paiements.",
        thisWeek:
          "💰 <strong>Cette semaine :</strong> {count} {payment} {verb} cette semaine.",
      },
      cutOffDocs: {
        today:
          "📄 <strong>Cut Off documents aujourd'hui :</strong> {count} {operation} {verb} la fermeture des documents aujourd'hui. Dernière chance !",
        tomorrow:
          "📄 <strong>Cut Off documents demain :</strong> {count} {operation} {verb} la fermeture des documents demain.",
        thisWeek:
          "📄 <strong>Cette semaine :</strong> {count} {operation} {verb} la fermeture des documents cette semaine.",
      },
      cutOffPhysical: {
        today:
          "📦 <strong>Cut Off physical aujourd'hui :</strong> {count} {operation} {verb} la fermeture physique aujourd'hui. Dernière chance !",
        tomorrow:
          "📦 <strong>Cut Off physical demain :</strong> {count} {operation} {verb} la fermeture physique demain.",
        thisWeek:
          "📦 <strong>Cette semaine :</strong> {count} {operation} {verb} la fermeture physique cette semaine.",
      },
      dateReleased: {
        today:
          "📋 <strong>Documents libérés aujourd'hui :</strong> {count} {document} {verb} aujourd'hui. L'importateur peut gérer la récupération.",
        tomorrow:
          "📋 <strong>Documents demain :</strong> {count} {document} {verb} demain.",
        thisWeek:
          "📋 <strong>Cette semaine :</strong> {count} {document} {verb} cette semaine.",
      },
      importPermit: {
        today:
          "🛂 <strong>Permis expirent aujourd'hui :</strong> {count} {permit} {verb} aujourd'hui. Critique ! Sans permis, ne peut pas être nationalisé.",
        tomorrow:
          "🛂 <strong>Permis demain :</strong> {count} {permit} {verb} demain. Renouvelez de toute urgence.",
        thisWeek:
          "🛂 <strong>Cette semaine :</strong> {count} {permit} {verb} cette semaine.",
      },
      payment_pending: {
        today:
          "⚠️ <strong>Paiements en attente aujourd'hui :</strong> {count} {payment} {verb} aujourd'hui. Urgent ! Ces paiements doivent être traités immédiatement.",
        tomorrow:
          "⚠️ <strong>Paiements en attente demain :</strong> {count} {payment} {verb} demain. Préparez-vous à traiter ces paiements.",
        thisWeek:
          "⚠️ <strong>Cette semaine :</strong> {count} {payment} {verb} cette semaine. Examinez et traitez les paiements en attente.",
      },
    },
    words: {
      vessel: { single: "navire", plural: "navires" },
      container: { single: "conteneur", plural: "conteneurs" },
      payment: { single: "paiement", plural: "paiements" },
      operation: { single: "opération", plural: "opérations" },
      document: { single: "jeu de documents", plural: "jeux de documents" },
      permit: { single: "permis", plural: "permis" },
      arrives: { single: "arrive", plural: "arrivent" },
      leaves: { single: "part", plural: "partent" },
      loads: { single: "est chargé", plural: "sont chargés" },
      goesOut: { single: "sort", plural: "sortent" },
      expires: { single: "expire", plural: "expirent" },
      has: { single: "a", plural: "ont" },
      releases: { single: "est libéré", plural: "sont libérés" },
    },
  },

  // Financial Summary translations
  financialSummary: {
    title: "Tableau de bord opérationnel",
    loading: "Chargement des données financières...",
    allGood: "Tous les aspects financiers sont en ordre",
    helpTitle: "Comprendre les Encaissements",
    close: "Fermer",
    pickShippingContainersTitle: "Quels emplacements conteneur ?",
    pickShippingContainersHint:
      "Cette proforma compte {total} emplacement(s). Choisissez ceux pour cette nouvelle expédition. Les emplacements déjà utilisés sont masqués.",
    pickShippingContainersNeedOne: "Sélectionnez au moins un emplacement.",
    pickShippingContainersNoneLeft:
      "Tous les emplacements conteneur de cette proforma sont déjà liés à une autre expédition.",
    pickShippingContainersNoneLeftTitle: "Aucun emplacement libre",
    pickShippingContainersConfirm: "Continuer",
    pickShippingContainersCancel: "Annuler",
    totalProform: "Total Proforma",
    totalBilled: "Total Facturé",

    expectedAmount: "Montant Attendu",
    advanceDeducted: "acompte déduit",
    shippingCollectionsApplied: "encaissements appliqués à l'expédition",
    commercialNotesCreditDeducted: "notes de crédit",
    commercialNotesDebitAdded: "notes de débit",
    collected: "Encaissé",
    pending: "En attente",
    pendingAdvance: "Acompte en attente",
    messages: {
      noPaymentCondition:
        "⚠️ <strong>Aucune condition de paiement configurée.</strong> Cette proforma n'a pas de pourcentage d'acompte défini.",
      noPaymentConditionDetails:
        "Configurez une condition de paiement pour suivre correctement les acomptes.",
      advancePending:
        "💰 <strong>Acompte en attente :</strong> L'acompte de {percentage}% (${amount}) doit être encaissé.",
      advancePendingDetails:
        "Aucun encaissement n'a encore été enregistré pour cette proforma.",
      advancePartial:
        "⏳ <strong>Acompte partiellement encaissé :</strong> ${collected} sur ${expected} ({percentage}% complété). <strong>${remaining} restant.</strong>",
      advancePartialDetails: "{count} encaissement(s) enregistré(s).",
      advanceComplete:
        "✅ <strong>Acompte entièrement encaissé :</strong> L'acompte prévu était de <strong>{percentage}%</strong> du total de la proforma (objectif <strong>{expected}</strong>) ; <strong>{amount}</strong> figure dans les encaissements.",
      advanceCompleteDetails: "{count} encaissement(s) enregistré(s).",
      shippingInvoicesPendingAfterAdvance:
        "📄 <strong>Factures d'expédition :</strong> {total} restent à encaisser sur {count} expédition(s) (après la part d'acompte proforma et les avoirs applicables).",
      hasShippings:
        "🚢 <strong>Cette proforma a {count} expédition(s).</strong>",
      hasShippingsDetails:
        "L'acompte (${advancePerShipping} par expédition) sera déduit lors de l'encaissement de chaque expédition.",
      readyForShipping:
        "📦 <strong>Prêt pour l'expédition :</strong> L'acompte a été encaissé.",
      readyForShippingDetails:
        "Vous pouvez maintenant créer des expéditions pour cette proforma.",
    },
    actions: {
      configure: "Configurer",
      addCollection: "Ajouter Encaissement",

      receivePayment: "Ajouter Encaissement",
    },
    // Modal messages
    collectionCreatedSuccessfully: "Encaissement créé avec succès",
    failedToOpenCollectionModal: "Échec de l'ouverture du modal d'encaissement",
    failedToSaveCollection: "Échec de l'enregistrement de l'encaissement",
    quickRequestPaymentTitle: "Demander un paiement (frais)",
    quickRequestPaymentHint:
      "Le paiement est créé pour ce frais uniquement. Le montant appliqué (payment_appliedto) suit le montant saisi. Choisissez le compte bancaire et un commentaire facultatif.",
    quickRequestPaymentAmountLabel: "Montant à demander",
    quickRequestPaymentBankLabel: "Compte bancaire (origine)",
    quickRequestPaymentCommentLabel: "Commentaire",
    quickRequestPaymentBankRequiredTitle: "Compte bancaire obligatoire",
    quickRequestPaymentBankRequiredText:
      "Sélectionnez le compte bancaire pour cette demande de paiement.",
    quickRequestPaymentSave: "Enregistrer",
    quickRequestPaymentMissingFields:
      "Impossible de charger les champs du paiement. Réessayez ou ouvrez le formulaire complet.",
    quickRequestPaymentOpenFailed:
      "Impossible d'ouvrir le formulaire de paiement rapide.",
    quickRequestPaymentAmountInvalidTitle: "Montant invalide",
    quickRequestPaymentAmountInvalidText:
      "Saisissez un montant strictement positif.",
    quickRequestPaymentAmountTooMuchTitle: "Montant trop élevé",
    quickRequestPaymentAmountTooMuchText:
      "Ne peut dépasser le solde en attente pour ce frais ({max}).",
    // Collection details modal
    viewCollections: "Voir les encaissements",
    collectionDetails: "Détails des Encaissements",
    collectedAmount: "Montant Encaissé",
    collections: "Encaissements",
    name: "Nom",
    amount: "Montant",
    status: "Statut",
    date: "Date",
    actionsColumn: "Actions",
    received: "Reçu",
    viewDetails: "Voir les détails",
    noCollections: "Aucun encaissement trouvé",
    errorLoadingCollectionDetails: "Erreur lors du chargement des détails",
    // Cash flow modal
    viewCashFlow: "Voir le flux de trésorerie",
    cashFlowDetails: "Détails du Flux de Trésorerie",
    collectionsIncome: "Encaissements (Revenus)",
    paymentsExpenses: "Paiements (Dépenses)",
    totalCollected: "Total Encaissé",
    totalPaid: "Total Payé",
    noPayments: "Aucun paiement trouvé",
    errorLoadingCashFlow: "Erreur lors du chargement du flux de trésorerie",
    // Additional shipping-specific translations
    shippingPending: "Expédition en attente d'encaissement",
    toCollect: "à encaisser",
    shippingPendingDetails:
      "Aucun encaissement n'a encore été enregistré pour cette expédition.",
    shippingPartial: "Encaissement partiel",
    of: "de",
    remaining: "restant",
    shippingComplete: "Expédition entièrement encaissée",
    collectionsRegistered: "encaissement(s) enregistré(s)",
    help: {
      advanceTitle: "Paiement d'Acompte",
      advanceDescription:
        "L'acompte est un pourcentage du total de la proforma que le client paie avant l'expédition de la marchandise. Il est configuré via le champ 'Condition de Paiement'.",
      calculationTitle: "Comment c'est calculé",
      calculationDescription:
        "Acompte Attendu = Total Proforma × Pourcentage d'Acompte. Par exemple, si la proforma est de 10 000$ et l'acompte est de 30%, l'acompte attendu est de 3 000$.",
      shippingTitle: "Expéditions et Acomptes",
      shippingDescription:
        "Lorsque vous encaissez depuis une expédition, le système déduit automatiquement l'acompte proportionnel déjà payé. Si la proforma a 2 expéditions et que 3 000$ ont été payés en acompte, chaque expédition déduit 1 500$.",
      exampleTitle: "Exemple Pratique",
      example1: "Proforma : 10 000$ avec 30% d'acompte",
      example2: "Acompte attendu : 3 000$ (encaissé avant l'expédition)",
      example3:
        "Lors de l'encaissement de l'expédition : Total expédition - (3 000$ ÷ nombre d'expéditions)",
    },
    // Section de paiements (pour les expéditions)
    payments: {
      title: "Paiements au Fournisseur",
      allGood: "Tous les paiements sont à jour",
      supplierTotal: "Total Fournisseur",
      total: "Total",
      requested: "Demandé",
      debitNotes: "notes de débit",
      expectedAdvance: "Acompte Attendu",
      paid: "Payé",
      pending: "En attente",
      totalExpenses: "Total Frais",
      expensesPaid: "Frais Payés",
      expensesPending: "Frais en Attente",
      addPayment: "Demander Paiement",
      completePayment: "Demander Paiement",
      requestAdvance: "Demander {percentage}%",
      requestFull: "Demander 100%",
      requestRemaining: "Compléter Acompte",
      requestBalance: "Demander Solde",
      paymentCreatedSuccessfully: "Paiement créé avec succès",
      failedToOpenPaymentModal:
        "Échec de l'ouverture du formulaire de paiement",
      failedToSavePayment: "Échec de l'enregistrement du paiement",
      advancePending:
        "🚚 <strong>Acompte fournisseur en attente :</strong> L'acompte de {percentage}% ({amount}) doit être payé au fournisseur avant l'expédition.",
      advancePendingDetails:
        "Enregistrez le paiement d'acompte au fournisseur/transporteur.",
      advancePartial:
        "⏳ <strong>Acompte partiellement payé :</strong> {paid} sur {expected} ({percentage}%). <strong>{remaining} restant</strong>",
      advancePartialDetails: "Complétez le paiement d'acompte au fournisseur.",
      advanceComplete:
        "✅ <strong>Acompte fournisseur complet :</strong> {amount} payé",
      advanceCompleteDetails:
        "Le paiement d'acompte au fournisseur a été complété.",
      balancePending: "Solde en attente : {amount} restant à demander.",
      balanceRequested:
        "Solde de {amount} demandé. En attente de confirmation de paiement.",
      requestAlreadySent: "Une demande de paiement a déjà été envoyée.",
      actionDisabledNoPermission:
        "Vous n'avez pas l'autorisation d'enregistrer des paiements fournisseur (finance.payments ou finance.manage).",
      actionDisabledNoCollectPermission:
        "Vous n'avez pas l'autorisation d'enregistrer des encaissements (finance.collects ou finance.manage).",
      balanceAwaitingHint:
        "Le solde a déjà été demandé ; confirmation du paiement en attente.",
      summaryPreparing: "Chargement du résumé des paiements…",
      emptySummaryTitle:
        "Aucune ligne de paiement fournisseur ou de frais pour l'instant",
      emptySummaryDetailsNoExpenses:
        "Il n'y a pas encore de montant de facture fournisseur à payer sur cette expédition et aucun frais d'expédition n'est enregistré. Ajoutez des montants dans les frais (et assurez-vous que l'opération a des totaux fournisseur) pour que les demandes de paiement apparaissent ici.",
      emptySummaryDetailsGeneric:
        "Il n'y a rien à afficher dans ce résumé pour l'instant. Lorsque l'opération aura des montants fournisseur ou des frais avec un montant, ils apparaîtront ici.",
      summaryLoadError: "Impossible de charger le résumé des paiements",
      summaryLoadErrorDetails:
        "Vérifiez la connexion et réessayez. Si le problème persiste, contactez le support.",
      supplierInvoicePending:
        "🚚 <strong>Facture fournisseur en attente :</strong> {amount} doit être payé au fournisseur.",
      supplierInvoicePendingDetails:
        "Enregistrez le paiement au fournisseur/shipper.",
      supplierInvoicePartial:
        "⏳ <strong>Paiement partiel fournisseur :</strong> {paid} sur {total} ({percentage}%). <strong>{remaining} restant</strong>",
      supplierInvoiceComplete:
        "✅ <strong>Facture fournisseur complète :</strong> {amount} payé",
      expensesPendingMsg:
        "📋 <strong>Frais en attente :</strong> {amount} de frais d'expédition à payer.",
      expensesPendingDetails:
        "Enregistrez les paiements des frais d'expédition.",
      expensesPartial:
        "⏳ <strong>Frais partiellement payés :</strong> {paid} sur {total} ({percentage}%). <strong>{remaining} restant</strong>",
      expensesComplete: "✅ <strong>Frais complets :</strong> {amount} payé",
      expense: "Frais",
      toPay: "à payer",
      of: "de",
      remaining: "restant",
      expenseNotPaidDetails: "Ce frais n'a pas encore été payé.",
      requested: "demandé",
      awaitingPayment:
        "Demande de paiement envoyée. En attente de confirmation de paiement.",
      payExpense: "Demander",
      completeExpense: "Demander",
    },
    // Operation Balance section
    balance: {
      title: "Bilan d'Opération",
      noData: "Données de bilan non disponibles",
      concept: "Concept",
      totalAmount: "Total",
      paid: "Payé",
      pending: "En attente",
      status: "Statut",
      complete: "Complet",
      partial: "Partiel",
      pendingStatus: "En attente",
      // Client section
      clientSection: "CLIENT (Revenus)",
      totalInvoice: "Total Facture",
      // Supplier section
      supplierSection: "FOURNISSEUR (Dépenses)",
      supplierInvoice: "Facture Fournisseur",

      costsSubtotal: "Sous-total Coûts",

      projectedMargin: "Marge Projetée",
      realMargin: "Marge Réelle",
      currentMargin: "Marge Actuelle",
      basedOnProforma: "basé sur proforma",
      basedOnAllRequests: "basé sur toutes les dépenses",
      basedOnPaidOnly: "paiements confirmés uniquement",
      proformaTotal: "Total Proforma",
      totalInvoices: "Total Factures",
      projected: "Projeté",
      invoice: "Facture",
      marginHelpAria: "Comment cette marge est calculée",
      marginHelp: {
        estimatedCosts: "Coûts estimés",
        bankCommissions: "Commissions bancaires",
        cashIn: "Encaissements (appliqués à cette opération)",
        collectedApplied: "Encaissements appliqués",
        creditNotes: "Avoirs appliqués",
        confirmedPaid: "Paiements confirmés (payés)",
        supplierPaid: "Fournisseur payé",
        costsPaid: "Autres coûts payés",
        projectedIntro:
          "La Marge Projetée utilise le total de la proforma moins les coûts estimés de cette opération :",
        projectedNote:
          "Les coûts estimés incluent la facture fournisseur, les autres frais d'expédition et les commissions bancaires.",
        realIntro:
          "La Marge Réelle utilise le total facture de cette opération moins les mêmes coûts estimés :",
        realNote:
          "Même base de coûts que la Marge Projetée ; seul le revenu change de proforma à facture.",
        currentIntro:
          "La Marge Actuelle est le flux de trésorerie réel de cette opération : déjà encaissé moins les paiements déjà marqués comme payés :",
        currentNote:
          "Elle n'utilise pas les demandes de paiement en attente ni le total facture complet — seulement les mouvements de caisse confirmés.",
      },
    },
  },

  "Financial Summary": "Résumé Financier",

  // Calendar Tutorial translations
  calendarTutorial: {
    // Welcome step
    calendarWelcome: {
      title: "Bienvenue dans le tutoriel du calendrier",
      description:
        "Je vais vous guider à travers les fonctionnalités du calendrier ExportAI et expliquer la signification des couleurs de statut d'expédition.",
      details: [
        "Vous apprendrez à naviguer dans le calendrier mensuel",
        "Vous comprendrez comment les événements et les dates importantes sont affichés",
        "Vous connaîtrez la signification de chaque couleur de statut d'expédition",
        "Vous saurez comment interagir avec les jours du calendrier et les événements",
      ],

      tip: "Le calendrier est votre outil principal pour visualiser et gérer toutes les dates importantes de vos opérations commerciales.",
    },

    // Calendar navigation step
    calendarNavigation: {
      title: "Navigation dans le calendrier",
      description:
        "Les boutons de navigation vous permettent de vous déplacer entre les mois pour voir les événements dans différentes périodes.",
      details: [
        "Bouton gauche : Revenir au mois précédent",
        "Bouton droit : Avancer au mois suivant",
        "Le mois et l'année actuels sont affichés au centre",
        "La navigation est instantanée et maintient votre vue actuelle",
      ],

      tip: "Utilisez la navigation pour planifier les opérations futures ou revoir les événements passés.",
    },

    // Calendar days step
    calendarDays: {
      title: "Jours du calendrier",
      description:
        "Chaque jour du calendrier affiche des informations visuelles sur les événements et les dates importantes.",
      details: [
        "Les jours du mois actuel sont affichés sur fond blanc",
        "Les jours des autres mois sont affichés en gris",
        "Le jour actuel est mis en évidence avec une bordure bleue",
        "Les jours avec événements ont un fond bleu clair",
      ],

      tip: "Les jours avec événements sont faciles à identifier par leur fond bleu clair.",
    },

    // Event display step
    eventDisplay: {
      title: "Affichage des événements",
      description:
        "Les événements sont affichés dans chaque jour du calendrier avec des informations pertinentes.",
      details: [
        "Chaque événement affiche le champ et le nom de l'élément",
        "Les événements d'expédition affichent des couleurs selon leur statut",
        "Les événements Proforma sont affichés en bleu standard",
        "Vous pouvez voir plusieurs événements le même jour",
      ],

      tip: "Les couleurs des événements vous donnent rapidement des informations sur l'état de vos opérations.",
    },

    // Shipping colors step
    shippingColors: {
      title: "Couleurs de statut d'expédition",
      description:
        "Les événements d'expédition sont affichés avec des couleurs spécifiques qui indiquent leur priorité et leur état.",
      details: [
        "Gris : Aucune priorité (état initial)",
        "Jaune : Opération en attente",
        "Orange : Opération retardée",
        "Bleu : Date de départ atteinte",
        "Rouge : Arrivée approchant (20 jours ou moins)",
        "Vert : Au port (état final)",
      ],

      tip: "Les couleurs vous permettent d'identifier rapidement quelles opérations nécessitent une attention immédiate.",
    },

    // Color meaning step
    colorMeaning: {
      title: "Signification des couleurs",
      description:
        "Chaque couleur représente un état spécifique calculé automatiquement par le système.",
      details: [
        "Le système calcule automatiquement le statut en fonction des dates",
        "Les couleurs changent automatiquement selon la progression de l'opération",
        "Le vert (au port) est l'état final souhaité",
        "Le rouge indique que l'arrivée approche et nécessite une attention",
      ],

      tip: "Gardez un œil sur les événements rouges et orange, car ils nécessitent une action immédiate.",
    },

    // Day interaction step
    dayInteraction: {
      title: "Interaction avec les jours",
      description:
        "Vous pouvez cliquer sur n'importe quel jour du calendrier pour voir plus de détails sur les événements.",
      details: [
        "Cliquez sur un jour avec événements pour voir la liste complète",
        "S'il n'y a qu'un seul événement, vous accéderez directement à ses détails",
        "S'il y a plusieurs événements, une modale s'ouvre avec la liste",
        "Depuis la modale, vous pouvez naviguer vers n'importe quel événement",
      ],

      tip: "Utilisez les clics sur les jours pour accéder rapidement aux informations détaillées sur vos opérations.",
    },

    // Event details step
    eventDetails: {
      title: "Panneau des événements du jour",
      description:
        "Le panneau de droite affiche les événements du jour sélectionné avec des options de navigation.",
      details: [
        "Affiche la date sélectionnée dans un format lisible",
        "Liste tous les événements du jour avec leur type et nom",
        "Chaque événement a un bouton pour voir ses détails complets",
        "Les événements sont regroupés par modèle (Proforma, Expédition)",
      ],

      tip: "Ce panneau vous donne une vue rapide de tout ce qui se passe un jour spécifique.",
    },

    // Completion step
    calendarCompletion: {
      title: "Tutoriel du calendrier terminé !",
      description:
        "Vous comprenez maintenant parfaitement comment fonctionne le calendrier et le système de couleurs d'expédition.",
      details: [
        "Navigation : Vous savez comment vous déplacer entre les mois et les jours",
        "Événements : Vous comprenez comment les événements sont affichés et organisés",
        "Couleurs : Vous connaissez la signification de chaque couleur de statut",
        "Interaction : Vous savez comment accéder aux informations détaillées",
      ],

      tip: "Le calendrier est maintenant votre outil principal pour gérer et visualiser toutes vos opérations commerciales !",
    },
  },
  // PDF Exporter translations
  pdfExporter: {
    exportToPdf: "Exporter en PDF",
    customizePdf: "Personnaliser le PDF",
    template: "Modèle",
    fieldsToInclude: "Champs à inclure",
    preview: "Aperçu",
    cancel: "Annuler",
    export: "Exporter",

    errorGeneratingPdf: "Erreur lors de la génération du PDF",
  },
  // Tree Edit translations
  treeEdit: {
    dragToMove: "Glisser pour déplacer",
    elementName: "Nom de l'élément",
    editElement: "Modifier l'élément",
    deleteElement: "Supprimer cet élément",

    accountingCode: "Code comptable pour les écritures",
    itemColor: "Couleur de l'élément",
    itemColorHint:
      "La couleur sert de fond à l'étiquette lorsque cet élément apparaît dans une liste. Sans couleur, il s'affiche en gris.",
    noColor: "Sans couleur",
    listTranslationsSection: "Traductions par langue (facultatif)",
    listTranslationsHint:
      "Si vous remplissez une langue, les utilisateurs verront ce texte lorsque l'interface est dans cette langue. Laissez vide pour utiliser le nom par défaut ci-dessus.",
  },
  // Template pages translations
  templatePages: {
    editRecord: "Modifier",
    printOrExport: "Imprimer ou exporter",
    pdfTextSize: "Taille du texte (impression)",
    pdfTextSizeHint:
      "Un texte plus petit permet de faire tenir plus de contenu sur une page à l’impression ou à l’enregistrement PDF.",

    retry: "Réessayer",
  },
  // AI translations
  ai: {
    analyzing: "Analyse en cours...",

    analyzeWithAI: "Analyse avec l'IA",
    analysisConfiguration: "Configuration de l'analyse",
    analysisPrompt: "Prompt d'analyse",
    clearResults: "Effacer les résultats",
    processing: "Traitement en cours...",
    aiAnalysis: "Analyse IA",

    analysisWithAI: "Analyse avec l'IA",
    hereToHelpTooltip: "Je suis là pour vous aider",

    customPrompts: "Prompts personnalisées",
    customPromptsChatHint:
      "Choisissez un prompt pour le charger dans le chat. Vous pouvez le modifier avant d’envoyer.",
    customPromptLoadedInChat:
      "J’ai chargé le prompt « {name} » dans le champ ci-dessous ; envoyez quand vous voulez.",
    deletePrompt: "Supprimer le Prompt",

    saveCustomPrompt: "Enregistrer le Prompt personnalisé",
    promptName: "Nom du Prompt",

    prompt: "Prompt",

    pleaseSelectAIModel: "Veuillez sélectionner un modèle d'IA",
    pleaseEnterPrompt: "Veuillez saisir un Prompt pour l'analyse",
    errorStartingAnalysis: "Erreur lors du démarrage de l'analyse",
    errorAnalyzingContent: "Erreur lors de l'analyse du contenu",
    errorCheckingStatus: "Erreur lors de la vérification du statut",

    errorGettingResult: "Erreur lors de la récupération du résultat",
    analysisFailed: "L'analyse a échoué",
    analysisTimeout: "L'analyse a pris trop de temps et a été annulée",
    errorCheckingAnalysisStatus:
      "Erreur lors de la vérification du statut de l'analyse",

    promptSaved: "Prompt enregistré",
    promptSavedSuccessfully:
      "L'invite personnalisée a été enregistrée avec succès et sera disponible pour les analyses futures.",

    errorSavingCustomPrompt:
      "Erreur lors de l'enregistrement du Prompt personnalisé",
    deletePromptQuestion: "Supprimer le Prompt ?",
    deletePromptConfirmation:
      'Êtes-vous sûr de vouloir supprimer l\'invite "{promptName}" ? Cette action ne peut pas être annulée.',
    yesDelete: "Oui, supprimer",
    promptDeleted: "Prompt supprimé",
    promptDeletedSuccessfully:
      "Le Prompt personnalisé a été supprimé avec succès.",
    errorDeletingPrompt: "Erreur lors de la suppression du Prompt",
    errorDeletingCustomPrompt:
      "Erreur lors de la suppression du Prompt personnalisé",
    accept: "Accepter",
    yes: "Oui",
    no: "Non",
    error: "Erreur",

    errorLoadingModels: "Erreur lors du chargement des modèles",
    errorLoadingRecords:
      "Erreur lors du chargement des enregistrements du modèle",
    errorInAnalysis: "Erreur dans l'analyse",
    errorCopyingToClipboard: "Erreur lors de la copie dans le presse-papiers",
    errorSavingToView: "Erreur lors de l'enregistrement dans la vue",

    itemCreateGenerateError: "Impossible de générer le JSON",
    itemCreateApplyError: "Impossible de créer l'enregistrement",
    itemCreateOriginalPrompt: "Demande initiale",
    itemCreateIntent: "Intention",
    itemCreateCreatedTitle: "Enregistrement créé",
    itemCreateCreatedBody:
      "Modèle : {model}. Vous pouvez ouvrir le nouvel enregistrement depuis la fiche.",
    itemCreateCreatedShort: "L'enregistrement a été créé.",

    itemModifySpecUserPrompt: "Demande utilisateur (Analyser avec l'IA) :",
    itemModifySpecAiResponse: "Réponse de l'analyse :",
    itemModifySpecPending: "Précisions manquantes",
    itemModifyFieldsHint: "Champs suggérés",

    itemModifyGenerateError: "Impossible de générer le JSON de mise à jour",
    itemModifyApplyError: "Impossible d'appliquer les modifications",
    itemModifySavedTitle: "Enregistrement mis à jour",
    itemModifySavedBody:
      "L'enregistrement a été enregistré. La page sera actualisée.",

    lastAiAnalysisSection: "Dernière analyse IA",
    viewHistoryItem: "Voir",

    conversationIntro:
      "Parlez en langage naturel : demandez une analyse, une mise a jour de champs ou la creation d'un enregistrement.",
    conversationPlaceholder:
      "Ex. : analyse cet enregistrement et liste les risques ; ou mets a jour le champ demande avec ce texte...",
    conversationSend: "Envoyer",
    conversationClear: "Reinitialiser la conversation",
    conversationLoading: "L'IA repond…",
    conversationGreeting:
      "Parfait, j'ai deja le contexte de cet enregistrement ({model}). Dites-moi ce qu'il faut faire et on le gere dans le chat.",

    listingAssistantIntro:
      "Créez un enregistrement, demandez des filtres pour restreindre la liste (l’IA construit l’URL comme la barre de filtres) ou posez des questions sur les champs. L’IA utilise la définition de ce listage. Pour une création, inutile d’avoir tous les champs d’avance : un brouillon suffit, le reste sur la fiche.",
    listingAssistantPlaceholder: "ex. : brouillon avec…, expliquez le champ X…",
    listingAssistantGreeting:
      "Vous êtes dans la liste « {model} ». Dites quel enregistrement générer ou ce dont vous avez besoin.",
    listingAssistantCreatedOk: "Terminé — l’enregistrement a été créé.",
    listingFiltersApplied:
      "Terminé — les filtres du listage ont été mis à jour (URL).",
    listingAssistantError: "L’action IA n’a pas pu aboutir.",
    supportFABAssistantIntro:
      "Posez vos questions en langage courant sur le fonctionnement du système, les formulaires, les expéditions ou les tickets. Je réponds avec des mots simples.",

    supportFABAssistantPlaceholder:
      "Ex. : un champ ne s’est pas rempli à la création d’une expédition, comment suivre un ticket, où modifier… ?",
    supportFABAssistantError: "L’assistant n’a pas pu terminer la réponse.",
    chatTurnNetworkSlow:
      "Le service est très lent ou n’a pas répondu à temps. Réessayez dans quelques minutes.",
    chatTurnTimeoutSlow:
      "La réponse a mis trop de temps. Réessayez un peu plus tard ou avec une question plus courte.",
    supportChatTurnTimeoutPartial:
      "La requête a dépassé le délai d’attente du navigateur, mais une partie de la réponse est déjà affichée ci-dessus. Renvoyez ou reformulez votre demande.",
    supportFABTechnicalIALabel: "Agent IA",

    supportFABChoiceReportBug: "Signaler un bug",
    supportFABChoiceChat: "Discuter",
    supportFABChoicePerformance: "Performance",
    supportFABPerformanceTitle: "Performance",
    supportFABPerformanceIntro:
      "Nous mesurons la connexion depuis votre navigateur. Si le support le demande, faites une capture d’écran de ce panneau.",
    supportFABPerformanceRefresh: "Actualiser la mesure",
    supportFABPerformanceCopy: "Copier les données",
    supportFABPerformanceCopied: "Données copiées dans le presse-papiers.",
    supportFABPerformanceCopyError: "Impossible de copier les données.",
    supportFABPerformanceLoading: "Mesure de la connexion…",
    supportFABPerformanceError: "Impossible de terminer la mesure.",
    supportFABPerformanceNotAvailable: "Non disponible",
    supportFABPerformanceSummary: "Résumé",
    supportFABPerformanceNetwork: "Réseau du navigateur",
    supportFABPerformanceOnline: "En ligne",
    supportFABPerformanceEffectiveType: "Type de connexion",
    supportFABPerformanceDownlink: "Débit estimé",
    supportFABPerformanceBrowserRtt: "RTT du navigateur",
    supportFABPerformanceSaveData: "Économie de données",
    supportFABPerformanceApiLatency: "Latence vers le serveur",
    supportFABPerformanceAvgLatency: "Moyenne",
    supportFABPerformanceMinMaxLatency: "Min / Max",
    supportFABPerformanceSamples: "Échantillons",
    supportFABPerformancePageLoad: "Chargement de cette page",
    supportFABPerformanceTtfb: "TTFB",
    supportFABPerformanceDomInteractive: "DOM interactif",
    supportFABPerformanceLoadTotal: "Chargement total",
    supportFABPerformanceEnvironment: "Environnement",
    supportFABPerformanceTimezone: "Fuseau horaire",
    supportFABPerformanceLocale: "Langue",
    supportFABPerformanceScreen: "Écran",
    supportFABPerformanceViewport: "Viewport",
    supportFABPerformanceScreenshotHint:
      "Envoyez une capture de cet écran au support s’il vous la demande.",
    supportFABPerformanceOffline: "Hors ligne",
    supportFABPerformanceStatusGood: "Bonne",
    supportFABPerformanceStatusModerate: "Moyenne",
    supportFABPerformanceStatusSlow: "Lente",
    supportFABPerformanceStatusUnknown: "Sans données",
    supportFABPerformanceGeneratedAt: "Mesure",

    promptHistoryTitle: "Historique du chat IA (résultats appliqués)",
    promptHistoryHint:
      "Enregistré sur votre compte lorsque le chat a appliqué des changements sur la fiche ou créé un enregistrement depuis le chat. Restaurez une demande ci-dessous pour la réutiliser ou l’ajuster.",
    promptHistoryRestoredHint:
      "Votre demande enregistrée est dans le champ ci-dessous ; vérifiez-la et envoyez quand vous voulez.",
    promptHistoryRestore: "Restaurer",
    promptHistoryRemove: "Retirer de l’historique",
    promptHistoryUntitled: "(sans titre)",

    promptHistoryKindChatModify: "Chat · modifications appliquées",
    promptHistoryKindChatCreate: "Chat · enregistrement créé",
    promptHistoryChatModifyNote:
      "Modifications appliquées à l’enregistrement depuis le chat.",
    promptHistoryChatCreateNote: "Nouvel enregistrement créé depuis le chat.",

    analysisInProgressTitle: "Analyse en cours",
    analysisInProgressMessage: "Analyse en cours : « {excerpt} »",
    viewContent: "Voir le contenu",
    cancelAnalysis: "Annuler",
    analysisCompletedTitle: "Analyse terminée",
    analysisCompletedMessage: "L’analyse IA s’est terminée avec succès.",
    analysisCancelledTitle: "Analyse annulée",
    analysisCancelledMessage: "L’analyse a été annulée.",
    analysisErrorTitle: "Erreur d’analyse",
    analysisErrorGeneric: "Une erreur s’est produite pendant l’analyse.",
    cancelAnalysisErrorTitle: "Annulation impossible",

    cancelAnalysisErrorRetry:
      "Impossible d’annuler l’analyse. Veuillez réessayer.",
    processingAnalysisProgress: "Traitement de l’analyse… {progress} %",

    progressBarPercent: "{progress} % terminé",
  },
  // Preferences translations
  savePreferences: "Enregistrer les préférences",
  preferencesSaved: "Préférences enregistrées avec succès",
  preferencesSaveError: "Erreur lors de l'enregistrement des préférences",
  savePreferencesTooltip:
    "Enregistrer les préférences actuelles pour les colonnes, l'ordre, les largeurs et les filtres",
  applyPreferencesToAllUsers:
    "Appliquer ces préférences à tous les utilisateurs",
  applyPreferencesToAllUsersHint:
    "Cela écrasera les préférences de tous les utilisateurs du système pour ce modèle",
  preferencesAppliedToAllUsers:
    "Préférences appliquées à tous les utilisateurs avec succès",
  // Column and report translations
  ColumnRemoved: "Colonne supprimée",
  LoadingColumnPreferences: "Chargement des préférences de colonnes...",
  NoRecordsAvailable: "Aucun enregistrement disponible",
  PleaseSelectColumns:
    "Veuillez sélectionner des colonnes dans le bouton bleu en haut à droite pour voir les informations dans cette liste",
  Column: "Colonne",
  restored: "restauré",
  New: "Nouveau",
  ImportJSON: "Importer JSON",
  SelectAll: "Tout sélectionner",
  BulkEdit: "Édition en masse",
  DeleteSelected: "Supprimer la sélection",
  Archive: "Archiver",
  ArchiveSelected: "Archiver la sélection",
  listTitleTrash: "Corbeille",
  listTitleArchive: "Archives",
  listTitleHidden: "Masqués",
  "Export to Excel": "Exporter vers Excel",
  "Hide empty date": "Masquer sans date",
  "Actions": "Actions",
  "Debit": "Débit",
  "Credit": "Crédit",
  "Attached File": "Fichier joint",
  "No transactions found matching your search": "Aucun mouvement ne correspond à la recherche",
  "Hide movements that have no date": "Masquer les mouvements sans date",
  "No payments found": "Aucun paiement trouvé",
  "No collects found": "Aucun encaissement trouvé",
  listTabActive: "Actifs",
  listTabArchived: "Archivés",
  listTabAll: "Tout",
  hide: "Masquer",
  hideInThisView: "Masquer dans cette vue",
  showInThisView: "Afficher dans cette vue",
  HideSelected: "Masquer la sélection",
  ShowSelected: "Afficher la sélection",
  "View archived": "Voir les archives",
  "This item is archived": "Cet élément est archivé",
  excelExportArchived: "Archivé",
  excelExportPaid: "Payé",
  excelExportUnpaid: "Impayé",
  Unarchive: "Désarchiver",
  UnarchiveSelected: "Désarchiver la sélection",
  "records archived successfully.": "enregistrements archivés avec succès.",
  "records archived": "enregistrements archivés",
  "An error occurred while archiving the records.": "Une erreur s'est produite lors de l'archivage des enregistrements.",
  "records unarchived successfully.": "enregistrements désarchivés avec succès.",
  "records unarchived": "enregistrements désarchivés",
  "An error occurred while unarchiving the records.": "Une erreur s'est produite lors du désarchivage des enregistrements.",
  "The record has been unarchived successfully.": "L'enregistrement a été désarchivé avec succès.",
  "An error occurred while unarchiving the record.": "Une erreur s'est produite lors du désarchivage de l'enregistrement.",
  SaveAsReport: "Enregistrer comme rapport",
  reportGroupByEmpty: "(sans valeur)",
  Reports: "Rapports",
  Choose: "Choisir",
  CreationDate: "Date de création",
  ReportLoaded: "Rapport chargé",
  ReportLoadedSuccessfully: 'Rapport "{name}" chargé avec succès',
  ErrorLoadingReport: "Erreur lors du chargement du rapport",
  // Report modal translations
  ReportName: "Nom du rapport",
  EnterReportName: "Entrez le nom du rapport",
  EnterReportDescription: "Entrez la description du rapport (optionnel)",
  MakeReportPublic:
    "Rendre ce rapport public (tous les utilisateurs peuvent y accéder)",
  ReportSaveInfo:
    "Cela enregistrera la configuration de la vue actuelle, y compris :",
  ReportSaveInfoColumns: "Les colonnes sélectionnées et leur ordre",
  ReportSaveInfoColumnLabels:
    "Titres de colonnes personnalisés (enregistrés avec le rapport)",
  ReportSaveInfoWidths: "Les largeurs des colonnes",
  ReportSaveInfoFilters: "Les filtres appliqués",
  ReportSaveInfoSort: "L'ordre de tri",
  ReportSaveInfoPagination: "Les paramètres de pagination",
  SaveReport: "Enregistrer le rapport",
  PleaseEnterReportName: "Veuillez entrer un nom de rapport",
  ReportIcon: "Icône du rapport",
  SearchIcon: "Rechercher une icône...",
  ReportSavedSuccessfully: "Rapport enregistré avec succès !",
  ErrorSavingReport: "Erreur lors de l'enregistrement du rapport",
  SavedReports: "Rapports enregistrés",
  Loading: "Chargement...",
  NoSavedReportsFound: "Aucun rapport enregistré trouvé",
  Name: "Nom",
  Visibility: "Visibilité",
  CreatedBy: "Créé par",
  Created: "Créé",
  Public: "Public",
  Private: "Privé",
  Unknown: "Inconnu",
  Load: "Charger",
  LoadReport: "Charger le rapport",
  EditReport: "Modifier le rapport",
  DeleteReport: "Supprimer le rapport",
  Close: "Fermer",
  Save: "Enregistrer",
  Copy: "Copier",
  Copied: "Copié",
  "Add new": "Ajouter",
  All: "Tous",
  Clear: "Effacer",
  editColumnDisplayName: "Nom de la colonne",
  editColumnDisplayNameHint:
    "Laissez vide ou le nom par défaut pour rétablir l'étiquette d'origine.",
  editColumnDisplayNameTooltip: "Personnaliser la colonne",
  editColumnDescription: "Description de la colonne",
  editColumnDescriptionHint:
    "Affichée au survol de l'icône « ? » de l'en-tête. Laissez vide pour rétablir la description du système, ou pour supprimer l'icône si le champ n'en a pas.",
  editColumnDescriptionTooltip: "Décrire cette colonne",
  editColumnDisplayNameTooLong: "200 caractères maximum",
  editColumnDisplayBold: "Gras",
  editColumnMoveToStart: "Envoyer au début",
  editColumnMoveToEnd: "Envoyer à la fin",
  editColumnGroupBy: "Grouper les lignes par cette colonne",
  ReportUpdatedSuccessfully: "Rapport mis à jour avec succès",
  ErrorUpdatingReport: "Erreur lors de la mise à jour du rapport",
  updateReport: "Mettre à jour le rapport",
  updateReportTooltip:
    "Mettre à jour le rapport chargé avec la configuration actuelle",

  ReportExited:
    "Vous avez quitté le rapport et êtes revenu à vos préférences enregistrées",
  ErrorExitingReport: "Erreur lors de la sortie du rapport",
  ViewingReport: "Visualisation du rapport",
  AreYouSure: "Êtes-vous sûr ?",
  ConfirmDeleteReport: 'Voulez-vous supprimer le rapport "{name}" ?',
  YesDeleteIt: "Oui, le supprimer",
  Deleted: "Supprimé",
  ReportDeletedSuccessfully: "Rapport supprimé avec succès",
  ErrorDeletingReport: "Erreur lors de la suppression du rapport",
  ErrorLoadingReports: "Erreur lors du chargement des rapports",
  ResizeColumn: "Redimensionner la colonne",
  Sort: "Trier",
  PinColumn: "Épingler la colonne",
  UnpinColumn: "Désépingler la colonne",
  "Select all": "Tout sélectionner",
  columnSelectorSelectedCount: "{count} colonnes sélectionnées",
  columnSelectorNoFields: "Aucun champ affichable",
  Cancel: "Annuler",
  Apply: "Appliquer",
  "Customize display": "Personnaliser l'affichage",
  "Clear filter": "Retirer le filtre",
  "Clear all": "Tout retirer",
  "Is empty": "Est vide",
  "Is not empty": "N'est pas vide",
  HideColumn: "Masquer la colonne",
  ImportCSV: "Importer CSV",
  AdvancedImport: "Importation avancée",
  ImportPresetSavedConfigs: "Configurations enregistrées",
  ImportPresetPickToApply: "— Appliquer une configuration —",
  ImportPresetSaveCurrent: "Enregistrer la configuration actuelle",
  ImportPresetPickToDelete: "— Supprimer une configuration —",
  ImportPresetHint:
    "Enregistrez le mapping CSV, le séparateur et les options de doublons / références pour les réutiliser. Vous pouvez appliquer n’importe quelle configuration ; les colonnes dont le nom correspond utiliseront le mapping enregistré. Le nom enregistré reprend celui du fichier importé (sans extension).",
  ImportPresetNamePrompt: "Nom de cette configuration",
  ImportPresetNameRequired: "Indiquez un nom pour enregistrer.",
  ImportPresetSavedOk: "Configuration enregistrée avec succès.",
  ImportPresetMismatch:
    "Les colonnes du fichier ne correspondent pas à cette configuration.",
  ImportPresetDeletedOk: "Configuration supprimée.",
  ImportPresetConfirmDelete: "Supprimer cette configuration enregistrée ?",
  ImportPresetNoFile: "Aucun fichier CSV",
  ImportPresetNoFileDetail:
    "Sélectionnez un fichier avant d'enregistrer cette configuration.",
  ImportSkipHooks: "Ignorer les hooks pendant l'import",
  ImportSkipHooksHelp:
    "Accélère l'import en évitant l'exécution des hooks/model hooks sur chaque ligne.",
  ImportErrorsLiveTitle: "Erreurs détectées pendant l'import",
  ImportRowPrefix: "Ligne",
  ImportGenericRowError: "Erreur lors de l'import de la ligne",
  ImportErrorAdminNote: "Détail technique visible pour le rôle admin.",
  ImportCreateMissingRefs: "Créer les références manquantes",
  ImportCreateMissingRefsHelp:
    "Si une valeur de référence n’existe pas, elle sera créée automatiquement en utilisant la valeur du fichier comme nom (name).",
  LoadingData: "Chargement des données...",
  // AI Model Context translations
  aiModelContext: {
    title: "Configuration du Contexte IA par Modèle",
    subtitle:
      "Définissez le contexte spécifique que l'IA doit avoir pour chaque modèle de données",
    configurePrompts: "Configurer les Prompts",
    goToAI: "Aller à l'IA",
    whatIsAIContext: "Qu'est-ce que le Contexte IA ?",
    aiContextDescription:
      "Le contexte IA est une information spécifique qui est envoyée à l'intelligence artificielle chaque fois qu'elle analyse des données d'un modèle particulier. Cela aide l'IA à comprendre :",
    whatModelRepresents: "Ce que représente le modèle",
    whatModelRepresentsDesc: "Son but et sa fonction dans l'entreprise",
    howToInterpretData: "Comment interpréter les données",
    howToInterpretDataDesc: "La signification de chaque champ",
    whatToLookFor: "Ce qu'il faut chercher dans l'analyse",
    whatToLookForDesc: "Aspects importants à considérer",
    businessContext: "Le contexte de l'entreprise",
    businessContextDesc: "Relations avec d'autres modèles",
    definitionModels: "Modèles de Définition",
    loading: "Chargement...",
    loadingModels: "Chargement des modèles...",
    noModelsDefined: "Aucun modèle défini",
    createModelsDescription:
      "Créez des modèles de définition pour pouvoir configurer leur contexte IA",
    createModel: "Créer un Modèle",
    model: "Modèle",
    label: "Étiquette",
    aiContext: "Contexte IA",
    status: "Statut",
    actions: "Actions",
    noLabel: "Sans étiquette",
    configured: "Configuré",
    notConfigured: "Non configuré",
    active: "Actif",
    configure: "Configurer",
    view: "Voir",
    configureAIContext: "Configurer le Contexte IA",
    modelLabel: "Modèle :",
    aiContextLabel: "Contexte IA *",
    aiContextGeneralLabel: "Contexte général du modèle",
    generalContextOptional:
      "Facultatif si les sections actions ou champs sont déjà remplies.",
    actionPromptsTitle: "Invites par action",
    actionEditItemLabel: "Modifier un élément",
    actionAddItemLabel: "Ajouter un élément",
    actionDeleteItemLabel: "Supprimer un élément",
    actionSearchItemLabel: "Rechercher un élément",
    actionPromptPlaceholder: "Instructions pour l'IA lorsque cette action s'applique…",
    fieldPromptsTitle: "Invites par champ",
    fieldPromptsHint:
      "Clé technique du champ (comme dans les filtres et le JSON). Seuls les textes non vides sont enregistrés.",
    fieldPromptPlaceholder: "Règles ou sens opérationnel de ce champ…",
    noFieldsInModel: "Ce modèle n'a pas de champs dans la définition.",
    saveRequiresOneSection:
      "Remplissez au moins un bloc : contexte général, une action ou un champ.",
    previewAsSentToAi: "Aperçu (tel qu'envoyé à l'IA)",
    previewGeneral: "Contexte général du modèle",
    previewActions: "Instructions par action",
    previewFields: "Instructions par champ (clé technique)",
    emptyPreview: "(aucun contenu)",
    aiContextPlaceholder:
      "Décrivez le contexte spécifique de ce modèle pour l'IA...",
    contextExamples: "Exemples de contexte :",
    example1:
      "Ce modèle représente des contacts commerciaux. Analysez la qualité des informations de contact, l'activité commerciale et les opportunités commerciales.",
    example2:
      "Ce modèle contient des produits du catalogue. Évaluez l'exhaustivité des informations, les prix compétitifs et la description du produit.",
    example3:
      "Ce modèle enregistre les transactions financières. Identifiez les modèles de dépenses, la catégorisation correcte et les anomalies possibles.",
    tipsForGoodContext: "Conseils pour un bon contexte :",
    tip1: "Expliquez ce que représente le modèle dans l'entreprise",
    tip2: "Décrivez les aspects importants à analyser",
    tip3: "Mentionnez les relations avec d'autres modèles s'il y en a",
    tip4: "Spécifiez le type d'insights que vous attendez d'obtenir",
    cancel: "Annuler",
    saving: "Enregistrement...",
    saveContext: "Enregistrer le Contexte",
    modelAIContext: "Contexte IA du Modèle",
    aiContextLabelView: "Contexte IA :",
    close: "Fermer",
    edit: "Éditer",
    error: "Erreur",
    errorLoadingModels: "Erreur lors du chargement des modèles",
    success: "Succès !",
    contextSavedSuccessfully: "Contexte IA enregistré avec succès",
    errorSavingContext: "Erreur lors de l'enregistrement du contexte",
  },
  // Dynamic Model Detail translations
  "Este contenido es un subitem de otro contenido.":
    "Ce contenu est un sous-élément d'un autre contenu.",
  "Para editar, debes ir al modelo padre y modificar el campo correspondiente.":
    "Pour modifier, vous devez aller au modèle parent et modifier le champ correspondant.",
  "Ir a la vista del item padre": "Aller à la vue de l'élément parent",
  "Ir al listado del modelo padre": "Aller à la liste du modèle parent",
  "Ver Item Padre": "Voir l'élément parent",
  "Ir al Modelo Padre": "Aller au modèle parent",
  "No hay campos definidos": "Aucun champ défini",
  "Contact ID is required to display Account Statement":
    "L'ID du contact est requis pour afficher le relevé de compte",
  "Bank Account ID is required to display Bank Account Statement":
    "L'ID du compte bancaire est requis pour afficher le relevé bancaire",
  "Análisis de Inteligencia Artificial": "Analyse d'intelligence artificielle",
  "Prompt utilizado:": "Invite utilisée :",
  "Resultado del análisis:": "Résultat de l'analyse :",
  "Información del análisis": "Informations de l'analyse",
  "Modelo:": "Modèle :",
  "Item:": "Élément :",
  "Fecha:": "Date :",
  "Contexto analizado": "Contexte analysé",
  "No hay información de contexto disponible":
    "Aucune information de contexte disponible",
  "Copiar análisis": "Copier l'analyse",
  "You won't be able to revert this action":
    "Vous ne pourrez pas annuler cette action",
  "The item has been deleted successfully.":
    "L'élément a été supprimé avec succès.",
  "Could not delete the item.": "Impossible de supprimer l'élément.",
  "N/A": "N/A",
  "Análisis de IA -": "Analyse IA -",
  "Prompt:": "Invite :",
  "Resultado:": "Résultat :",
  "Copiado al portapapeles": "Copié dans le presse-papiers",
  "El análisis se ha copiado correctamente":
    "L'analyse a été copiée correctement",
  "No se pudo copiar automáticamente": "Impossible de copier automatiquement",
  "Por favor, selecciona y copia el texto manualmente":
    "Veuillez sélectionner et copier le texte manuellement",
  Entendido: "Compris",
  "No hay estructura de contenido disponible":
    "Aucune structure de contenu disponible",
  "Estructura jerárquica del registro":
    "Structure hiérarchique de l'enregistrement",
  "ID del item:": "ID de l'élément :",
  "GRUPOS ORGANIZACIONALES:": "GROUPES ORGANISATIONNELS :",
  "GRUPO:": "GROUPE :",
  "Icono:": "Icône :",
  REQUERIDO: "REQUIS",
  ARRAY: "TABLEAU",
  "(vacío)": "(vide)",
  elementos: "éléments",
  "(sin valor)": "(sans valeur)",
  "(objeto complejo)": "(objet complexe)",
  "(objeto)": "(objet)",
  "CAMPOS INDEPENDIENTES:": "CHAMPS INDÉPENDANTS :",
  Item: "Élément",

  // Months
  months: {},

  // Website Module
  websites: {
    title: "Sites Web",
    subtitle: "Gérez vos sites web et domaines",
    menuItem: "Websites",
    createWebsite: "Créer un Site Web",
    editWebsite: "Modifier le Site Web",
    name: "Nom",
    description: "Description",
    domain: "Domaine",
    status: "Statut",
    createdAt: "Date de création",
    actions: "Actions",
    active: "Actif",
    inactive: "Inactif",
    isActive: "Actif",
    edit: "Modifier",
    delete: "Supprimer",
    noWebsites: "Aucun site web trouvé",
    noWebsitesHint:
      "Créez votre premier site web en utilisant le bouton ci-dessus",
    searchPlaceholder: "Rechercher des sites web...",
    namePlaceholder: "Nom du site web",
    descriptionPlaceholder: "Description du site web (optionnel)",
    domainPlaceholder: "exemple.com",
    domainHint:
      "Optionnel. Configurez le domaine quand vous voulez publier le site.",
    saving: "Enregistrement...",
    created: "Site web créé avec succès",
    updated: "Site web mis à jour avec succès",
    deleted: "Site web supprimé avec succès",
    confirmDelete: 'Voulez-vous supprimer le site web "{name}" ?',
    requiredFields: "Veuillez remplir les champs obligatoires",
    errorLoading: "Erreur lors du chargement des sites web",
    errorSaving: "Erreur lors de l'enregistrement du site web",
    errorDeleting: "Erreur lors de la suppression du site web",
    preview: "Aperçu",
  },

  // Pages (Website Module)
  pages: {
    title: "Pages",

    createPage: "Créer une Page",
    editPage: "Modifier la Page",
    slug: "Slug",
    model: "Modèle",

    status: "Statut",

    actions: "Actions",
    active: "Actif",
    inactive: "Inactif",

    noPages: "Aucune page",
    noPagesHint: "Créez votre première page en utilisant le bouton ci-dessus",
    searchPlaceholder: "Rechercher des pages...",

    created: "Page créée avec succès",
    updated: "Page mise à jour avec succès",
    deleted: "Page supprimée avec succès",
    confirmDelete: 'Voulez-vous supprimer la page "{slug}" ?',
    requiredFields: "Le slug est obligatoire",

    errorSaving: "Erreur lors de l'enregistrement de la page",
    errorDeleting: "Erreur lors de la suppression de la page",
    preview: "Aperçu",

    shortcodeIf: "Affiche le contenu si le champ existe",
    shortcodeHidden: "Cache dans certains dbNames",
    shortcodeShow: "Affiche seulement dans certains dbNames",
    shortcodeFor: "Itère sur un tableau",

    conditionals: "Conditionnels",
    loops: "Boucles",
    visibility: "Visibilité",
    operators: "Opérateurs",
    loopVars: "Variables de boucle",
    loopIndex: "Index actuel (0, 1, 2...)",
    loopFirstLast: "Premier/dernier élément",

    // Visual Editor
    editor: {
      loading: "Chargement de l'éditeur...",
      splitView: "Vue divisée",
      codeOnly: "Code uniquement",
      previewOnly: "Aperçu uniquement",
      openInBrowser: "Ouvrir dans le navigateur",
      save: "Enregistrer",
      saving: "Enregistrement...",
      configuration: "Configuration",
      urlSlug: "URL (slug)",
      pageActive: "Page active",
      dataSource: "Source de données",
      noData: "Sans données",
      selectModel: "Sélectionner un modèle...",
      selectReport: "Sélectionner un rapport...",
      elements: "Éléments",
      title: "Titre",
      text: "Texte",
      image: "Image",
      button: "Bouton",
      divider: "Diviseur",
      container: "Conteneur",
      columns: "Colonnes",
      list: "Liste",
      card: "Carte",
      hero: "Hero",
      gallery: "Galerie",
      video: "Vidéo",
      blocks: "Blocs",
      media: "Médias",
      uploadImage: "Télécharger une image",
      noMedia: "Aucune image",
      clickToInsert: "Cliquez pour insérer",
      uploadError: "Erreur lors du téléchargement",
      confirmDeleteMedia: "Supprimer cette image ?",
      files: "Fichiers CSS/JS",
      noFiles: "Aucun fichier",
      manageFiles: "Gérer les fichiers",
      fileInserted: 'Shortcode du fichier "{name}" inséré',
      variables: "Variables",
      insertLoop: "Insérer une boucle t-for",
      logic: "Logique",
      conditional: "Conditionnel",
      ifElse: "If/Else",
      loop: "Boucle",
      hideFor: "Masquer pour",
      showFor: "Afficher pour",
      html: "HTML",
      formatCode: "Formater le code",
      livePreview: "Aperçu en direct",
      refresh: "Actualiser",
      noSampleWarning: "Pas de données d'exemple",
      writePlaceholder:
        "Écrivez votre HTML ici ou utilisez les éléments du panneau de gauche...",
    },
    // Page Import
    importFromHtml: "Importer depuis HTML",
    importHtmlSimpleHelp:
      "Collez votre code HTML. Les fichiers CSS et JavaScript seront automatiquement extraits et enregistrés comme fichiers du site.",

    baseUrl: "URL de base du site",
    baseUrlHint:
      "Pour résoudre les URLs relatives (ex: /css/style.css → https://exemple.com/css/style.css)",
    pasteHtml: "Collez votre code HTML ici:",
    htmlPlaceholder:
      "<!DOCTYPE html>\n<html>\n<head>...</head>\n<body>\n  <header>...</header>\n  <main>...</main>\n  <footer>...</footer>\n</body>\n</html>",
    importPage: "Importer la page",
    importing: "Importation...",
    importSuccess:
      "Page importée avec succès. {files} fichiers CSS/JS extraits.",
    importError: "Erreur lors de l'importation de la page",

    generateBlocksWithAI: "Générer des blocs avec l'IA",
    analyzing: "Analyse en cours...",
    aiAnalysisResults: "Résultats de l'analyse IA",
    blocksDetected: "Blocs détectés",
    pagePreview: "Aperçu de la page",
    createSelectedBlocks: "Créer les blocs sélectionnés",
    createBlocksAndUpdatePage: "Créer les blocs et mettre à jour la page",
    noBlocksDetected: "Aucun bloc détecté",
    htmlRequired: "Le HTML est requis",

    analyzeError: "Erreur lors de l'analyse du HTML",
    generateBlocksInfo:
      "Les blocs sélectionnés seront créés et le contenu de la page sera mis à jour, remplaçant le HTML original par les shortcodes des blocs.",
    pageContentAfter: "Contenu de la page (après)",
    pageUpdatedWithBlocks: "Page mise à jour avec {blocks} blocs créés",
    noContentToAnalyze: "Cette page n'a pas de contenu à analyser",
    errorUpdating: "Erreur lors de la mise à jour de la page",
    deletePage: "Supprimer la page",

    noBlocksDetected: "Aucun bloc réutilisable détecté",

    pageCreatedWithBlocks: "Page créée avec {blocks} blocs",
    slugRequired: "Le slug est obligatoire",

    errorCreating: "Erreur lors de la création de la page",
  },

  // Blocks (Website Module)
  blocks: {
    title: "Blocs",

    createBlock: "Créer un Bloc",
    editBlock: "Modifier le Bloc",
    name: "Nom",

    model: "Modèle",
    content: "Contenu",
    status: "Statut",
    actions: "Actions",
    shortcode: "Shortcode",
    isActive: "Actif",
    noBlocks: "Aucun bloc",
    noBlocksHint: "Créez votre premier bloc en utilisant le bouton ci-dessus",
    searchPlaceholder: "Rechercher des blocs...",
    contentPlaceholder: "<header>\n  <nav>...</nav>\n</header>",
    created: "Bloc créé avec succès",
    createdCount: "{count} blocs créés avec succès",
    createError: "Erreur lors de la création des blocs",
    updated: "Bloc mis à jour avec succès",
    deleted: "Bloc supprimé avec succès",
    confirmDelete: 'Voulez-vous supprimer le bloc "{name}" ?',
    requiredFields: "Le nom est obligatoire",
    nameRequired: "Le nom du bloc est obligatoire",
    namePlaceholder: "Ex: Header Principal",
    newBlock: "Nouveau Bloc",
    blockActive: "Bloc actif",
    noItemId: "Sans Item ID",
    fromUrl: "Depuis URL (?itemId=...)",
    fixedId: "ID fixe",
    errorSaving: "Erreur lors de l'enregistrement du bloc",
    errorDeleting: "Erreur lors de la suppression du bloc",
    types: {},
    modelConfig: "Configuration du Modèle",
    noModel: "Aucun modèle",
    itemIdSource: "Source de l'Item ID",
    itemIdNone: "Aucun (aléatoire)",
    itemIdUrl: "Depuis l'URL (?itemId=...)",
    itemIdFixed: "ID fixe (codé en dur)",
    itemIdSourceHelp: "D'où obtenir l'ID de l'élément",
    fixedItemId: "Item ID fixe",
    fixedItemIdPlaceholder: "ID du document",
    // HTML Import with AI
    importFromHtml: "Importer depuis HTML",
    importHtmlHelp:
      "Collez votre code HTML et l'IA identifiera automatiquement les blocs réutilisables tels que les en-têtes, pieds de page, sections hero, etc.",
    pasteHtml: "Collez votre code HTML ici:",
    htmlPlaceholder:
      '<html>\n<head>...</head>\n<body>\n  <header>...</header>\n  <section class="hero">...</section>\n  <footer>...</footer>\n</body>\n</html>',
    analyzeWithAi: "Analyser avec l'IA",
    analyzing: "Analyse en cours...",
    blocksFound: "{count} blocs trouvés",
    analyzeAnother: "Analyser un autre HTML",
    selectAtLeastOne: "Sélectionnez au moins un bloc à créer",
    createSelected: "Créer {count} blocs sélectionnés",
    noBlocksFound: "Aucun bloc réutilisable trouvé dans le HTML",
    analyzeError: "Erreur lors de l'analyse du HTML",
    blocksCreated: "{count} blocs créés avec succès",
    someBlocksFailed: "{count} blocs n'ont pas pu être créés",
    errorCreating: "Erreur lors de la création des blocs",
  },

  // Menus (Website Module)
  menus: {
    locations: {},
  },

  // Files (Website Module - CSS/JS)
  files: {
    title: "Fichiers",

    createFile: "Créer Fichier",
    editFile: "Modifier Fichier",
    name: "Nom",
    type: "Type",
    source: "Source",
    url: "URL",
    content: "Contenu",
    status: "Statut",
    actions: "Actions",
    shortcode: "Shortcode",
    isActive: "Actif",
    isExternal: "Fichier externe (CDN)",
    isExternalHint:
      "Activer si le fichier est sur un CDN externe (URL uniquement). Désactiver pour le code local.",
    noFiles: "Aucun fichier",
    noFilesHint:
      "Les fichiers CSS/JS seront créés automatiquement lors de l'import HTML ou vous pouvez les créer manuellement",
    searchPlaceholder: "Rechercher fichiers...",
    nameHint: "Inclure l'extension (.css ou .js)",
    created: "Fichier créé avec succès",
    updated: "Fichier mis à jour avec succès",
    deleted: "Fichier supprimé avec succès",
    confirmDelete: 'Voulez-vous supprimer le fichier "{name}" ?',

    errorSaving: "Erreur lors de l'enregistrement du fichier",
    errorDeleting: "Erreur lors de la suppression du fichier",
  },

  // Media
  media: {
    title: "Médias",

    upload: "Télécharger un fichier",
    name: "Nom",
    url: "URL",

    noMedia: "Aucun fichier multimédia",
    noMediaHint:
      "Les images seront importées automatiquement du HTML ou vous pouvez les télécharger manuellement",
    searchPlaceholder: "Rechercher des médias...",
    delete: "Supprimer",
    copyUrl: "Copier l'URL",
    urlCopied: "URL copiée dans le presse-papiers",
    copyError: "Erreur lors de la copie de l'URL",
    deleted: "Fichier multimédia supprimé",
    confirmDelete: 'Voulez-vous supprimer le fichier "{name}" ?',
    errorDeleting: "Erreur lors de la suppression du fichier",
    uploadHint:
      "Pour télécharger des images, utilisez l'éditeur de pages ou importez du HTML avec des images",
  },

  // Accounting Module
  accounting: {
    journalEntries: "Écritures Comptables",

    generateEntry: "Générer Écriture",
    viewEntry: "Voir Écriture",
    editEntry: "Modifier Écriture",
    newEntry: "Nouvelle Écriture",
    entryNumber: "Numéro d'Écriture",
    entryGenerated: "Écriture Générée avec Succès",
    errorGenerating: "Erreur lors de la génération de l'écriture",
    regenerateEntry: "Régénérer l'Écriture",
    regenerate: "Régénérer",
    regenerateConfirmText:
      "Cela mettra à jour l'écriture avec les données actuelles du document source (numéros de compte, montants, etc.)",
    regenerateSuccess: "Écriture Régénérée",
    regenerateSuccessText:
      "L'écriture a été mise à jour avec les données actuelles.",
    regenerateError: "Erreur lors de la régénération de l'écriture",

    generateAllEntries: "Générer Toutes les Écritures",
    confirmGenerateAll: "Générer Toutes les Écritures ?",
    confirmGenerateAllText:
      "Cela générera des écritures comptables pour toutes les transactions en attente de cette opération.",
    generate: "Générer",
    generationResults: "Résultats de Génération",
    generated: "Générées",
    skipped: "Ignorées",
    errors: "Erreurs",
    entriesGenerated: "Écritures Générées",
    noNewEntries: "Aucune Nouvelle Écriture",
    allEntriesExist:
      "Toutes les écritures comptables existent déjà pour cette opération.",
    export: "Exporter vers Excel",
    exportExcel: "Exporter vers Excel",
    exportCSV: "Exporter vers CSV",

    noEntries: "Aucune écriture comptable trouvée",
    noEntriesHint:
      "Générez des écritures depuis l'onglet Finance d'un Shipping ou Proforma",
    searchPlaceholder: "Rechercher par concept, compte...",
    totalItems: "{count} écriture(s)",
    showingItems: "Affichage de {from}-{to} sur {total}",

    // Date fields
    date: "Date",
    dateFrom: "Date De",
    dateTo: "Date À",
    day: "Jour",
    year: "Année",
    month: "Mois",

    accountNumber: "Numéro de Compte",
    accountName: "Nom du Compte",
    searchAccount: "Rechercher par numéro ou nom…",
    accountNotInChart: "Absent du plan comptable",
    chooseAccounts: "Choisissez le compte de débit et de crédit",
    debit: "Débit",
    credit: "Crédit",

    // Transaction fields
    concept: "Concept",
    conceptPlaceholder: "ex., ENCAISSEMENT ACOMPTE PI 4803/2025",
    amount: "Montant",
    total: "Total",
    currency: "Devise",
    notes: "Notes",
    notesPlaceholder: "Notes supplémentaires (optionnel)",
    sourceDocument: "Document Source",
    entryType: "Type d'Écriture",

    // Currency names
    currencies: {
      ARS: "Peso Argentin",
      USD: "Dollar Américain",
      EUR: "Euro",
      GBP: "Livre Sterling",
      CNY: "Yuan Chinois",
    },

    // Entry types
    types: {
      collect_advance: "Encaissement Acompte Client",
      collect_balance: "Encaissement Solde Client",
      payment_advance: "Paiement Acompte Fournisseur",
      payment_expense: "Paiement de Dépense",
      payment_bank_to: "Paiement compte bancaire (destinataire)",
      invoice_client: "Facture Client",
      expense_load: "Chargement de Dépense",

      other: "Manuel / Autre",
    },

    // Delete all
    deleteAll: "Tout Supprimer",
    deleteAllConfirmTitle: "Supprimer toutes les écritures?",
    deleteAllConfirmText:
      "Cette action supprimera TOUTES les écritures comptables. Cette action ne peut pas être annulée.",
    deleteAllWarning: "ATTENTION: Cette action est irréversible!",
    typeToConfirm: "Tapez 'delete all' pour confirmer",
    typeDeleteAllToConfirm: "Vous devez taper 'delete all' pour confirmer",
    deleteAllSuccess: "Écritures supprimées",
    deleteAllSuccessText: "{count} écriture(s) supprimée(s) avec succès.",
    deleteAllError: "Erreur lors de la suppression de toutes les écritures",
  },

  // Instance Builder
  instanceBuilder: {
    title: "Instance Builder",
    subtitle:
      "Décrivez l'application dont vous avez besoin et l'IA générera la configuration",
    describeApp: "Décrivez votre application",
    placeholder:
      "Ex: J'ai besoin d'un système pour gérer une agence immobilière avec des propriétés, des clients, des contrats et des paiements...",
    orChooseExample: "Ou choisissez un exemple:",
    generate: "Générer la configuration",
    generating: "Génération en cours...",
    waitMessage:
      "L'IA traite votre demande. Cela peut prendre jusqu'à 2 minutes...",
    modifyConfig: "Modifier la configuration",
    generatedConfig: "Configuration générée",
    simpleView: "Vue simple",
    viewJson: "Voir JSON",
    lists: "Listes",
    models: "Modèles",
    fields: "champs",
    values: "valeurs",
    startOver: "Recommencer",
    previewChanges: "Aperçu des modifications",
    applyConfig: "Appliquer la configuration",
    applying: "Application en cours...",
    configApplied: "Configuration appliquée!",
    modelsCreated: "Modèles créés",
    listsCreated: "Listes créées",
    viewModels: "Voir les modèles",
    createMore: "Créer plus",
    newModels: "Nouveaux modèles",
    newLists: "Nouvelles listes",
    none: "Aucun",
    overwriteExisting: "Écraser les modèles/listes existants",
    cancel: "Annuler",
    confirmApply: "Confirmer et appliquer",
    chatPlaceholder: "Ex: Ajouter un champ téléphone au modèle Client...",
    configGenerated:
      "J'ai généré une configuration avec {models} modèles et {lists} listes. Voulez-vous apporter des modifications?",
    changesAdded:
      "J'ai ajouté les modifications à la configuration. Vous pouvez les voir dans le panneau de droite.",
    modified:
      "J'ai modifié {target}. Les modifications sont reflétées dans la configuration.",
    deleted: "J'ai supprimé {target} de la configuration.",
    notUnderstood:
      "Je n'ai pas bien compris quelle modification vous souhaitez faire. Pouvez-vous être plus précis?",
    chatError:
      "Une erreur s'est produite lors du traitement de votre message. Veuillez réessayer.",
    // Suggestions
    suggestions: {
      realEstate: "Immobilier",
      realEstateDesc:
        "Système de gestion immobilière avec propriétés, propriétaires, clients intéressés, contrats de location et vente, et suivi des paiements",
      gym: "Salle de sport",
      gymDesc:
        "Système de salle de sport avec clients, abonnements, cours, instructeurs et suivi des présences",
      veterinary: "Vétérinaire",
      veterinaryDesc:
        "Système de clinique vétérinaire avec animaux, propriétaires, historique médical, vaccins, rendez-vous et traitements",
      restaurant: "Restaurant",
      restaurantDesc:
        "Système de restaurant avec tables, réservations, commandes, menu avec plats et catégories, et facturation",
      school: "École",
      schoolDesc:
        "Système scolaire avec étudiants, professeurs, matières, notes, présences et communications",
      ecommerce: "E-commerce",
      ecommerceDesc:
        "Boutique en ligne avec produits, catégories, clients, commandes, panier et méthodes de paiement",
    },
  },

  jurisprudencia: {
    menuItem: "Jurisprudence",
    browsePageTitle: "Jurisprudence",

    browseAiPlaceholder:
      "Ex. : arrêts de la CSJN sur le dommage moral dans les accidents de la route",
    browseAiButton: "Rechercher avec l’IA",

    adminSaijApiDebugTitle:
      "Débogage requête SAIJ (administrateurs uniquement)",
    adminSaijApiDebugIntro:
      "Inclut le paramètre q (wire), la chaîne de facettes f, l’URL GET vers resultados.jsp et, en secours, le POST vers /busqueda (champs et corps application/x-www-form-urlencoded).",

    browseColTitle: "Titre",
    browseColJurisdiction: "Juridiction",
    browseColTribunal: "Juridiction / organe",
    browseColDate: "Date",
    browseColTipoFallo: "Type d’arrêt",

    browseColSnippet: "Extrait",

    browseColLink: "Lien",

    agentChatCardLabel: "Assistant jurisprudence",

    agentChatPlaceholder: "Saisissez un message et envoyez…",
    agentChatHistoryAnalyzeHint:
      "Vous consultez des résultats enregistrés dans l’historique. Vous pouvez me demander de les analyser (par ex. « analyse ceux qui sont pertinents ») : je surlignerai en vert les arrêts qui correspondent, sans relancer la recherche SAIJ.",
    agentOpeningGreetingLoading:
      "Préparation d’un message d’accueil avec l’IA…",

    agentChatSend: "Envoyer",
    agentChatClear: "Réinitialiser la conversation",
    agentChatLoading: "Réflexion…",
    searchDoneTitle: "Recherche terminée (assistant)",

    newAgentChat: "Nouvelle conversation assistée",
    searchHistoryTitle: "Historique des recherches enregistrées",
    searchHistoryToggle: "Voir l’historique ({n})",
    searchHistoryViewResults: "Voir les résultats",
    searchHistoryNoResultsStored:
      "Cette entrée n’a pas de résultats enregistrés. Utilisez « Relancer ».",
    searchHistoryLegacyBadge: "Pas de copie",
    searchHistorySourceQuick: "Rapide",
    searchHistorySourceDemanda: "Depuis l’acte",
    searchHistorySourceAgent: "Assistant",
    searchHistoryDelete: "Supprimer",
    searchHistoryDeleteTitle: "Supprimer de l’historique",
    searchHistoryDeleteConfirm:
      "Cette recherche enregistrée et ses résultats seront supprimés. Continuer ?",
    searchHistoryRerun: "Relancer",
    searchRerunDoneHint:
      "Recherche enregistrée relancée. Résultats mis à jour ci-dessous.",
    browseQuickAiSummary: "Recherche IA rapide (un seul message)",

    browseQuickAiResultsHint:
      "Recherche rapide : liste d’arrêts dans l’index (pas d’analyse de pertinence tant que vous ne la demandez pas).",

    pageTitle: "Jurisprudence",
    pageIntro:
      "Ce module est l’assistant ExportAI pour le SAIJ argentin (législation, arrêts, sommaires, avis, doctrine). La recherche automatique intégrée est aujourd’hui centrée sur la jurisprudence nationale ; depuis un Écrit (MEV, nom technique « Demanda ») vous pouvez lancer cette recherche assistée par IA à partir du texte.",
    pageHintDemanda:
      "Sur un enregistrement « Écrit », utilisez la recherche SAIJ : un chat s’ouvre avec le même assistant que Jurisprudence, le texte de l’acte est en contexte et vous pouvez affiner avant de lancer la recherche.",

    searchRelated: "Rechercher la jurisprudence liée (SAIJ)",
    modalTitle: "Recherche SAIJ depuis l’acte",
    escritoJurisModalIntro:
      "Discutez avec l’assistant comme dans Jurisprudence : le texte de votre acte est déjà en contexte. Quand la recherche est prête, l’assistant l’exécute sur le SAIJ et les résultats s’affichent ci-dessous.",
    escritoJurisShortContextHint:
      "Peu de texte a été chargé depuis l’acte ; vous pouvez tout de même guider l’assistant avec vos messages.",
    escritoJurisGreetingLoading: "Préparation de l’assistant…",
    escritoJurisFallbackGreeting:
      "Bonjour. J’ai déjà votre acte : dites-moi quelle jurisprudence chercher ou quels points vous intéressent.",
    loading: "Recherche…",

    aiRelevantBadge: "Pertinent (IA)",
    stopAgentTurn: "Arrêter",
    turnStoppedByUser:
      "Vous avez interrompu l’opération. Les résultats déjà affichés restent : vous pouvez cocher des liens et enregistrer, ou réessayer plus tard.",
    chatErrorNetworkOrSaij:
      "L’opération n’a pas pu aboutir (réseau ou le site SAIJ n’a pas répondu correctement). C’est souvent une surcharge ou lenteur du moteur officiel saij.gob.ar, pas une panne durable de ExportAI. Réessayez plus tard, en heures creuses, ou avec « Arrêter » et une recherche plus ciblée.",
    chatErrorTimeoutSaij:
      "Délai d’attente dépassé. Quand le SAIJ est très lent, la recherche ou l’analyse peut être interrompue ; cela ne signifie pas que votre acte ou votre demande est incorrect. Réessayez plus tard, la nuit, ou limitez le nombre de résultats.",

    progress: {},
    emptyDemandPopupTitle: "Écrit sans texte à analyser",
    emptyDemandPopupText:
      "Il n’y a pas de texte utile dans « Contenu » ni dans les sections de rédaction, ou rien n’est enregistré sur le serveur. Saisissez ou enregistrez l’écrit puis réessayez.",
    emptyDemandPlantillaTitle: "Aucun texte à analyser",
    emptyDemandPlantillaText:
      "Un modèle est sélectionné mais il n’y a pas de texte dans les sections de rédaction, pas de version texte utile sur l’enregistrement, ou le modèle n’a pas pu être chargé. Enregistrez l’enregistrement, vérifiez le corps du modèle, ou complétez « Contenu » puis réessayez.",

    hint: "Arrêts de l’index public SAIJ. Si vous demandez une analyse, le serveur télécharge un fragment de texte depuis l’URL de chaque résultat et l’IA l’utilise avec le titre et l’extrait (toujours un extrait ; lisez l’arrêt complet sur le site officiel). Vérifiez chaque citation sur saij.gob.ar.",
    whyThisResult: "Pourquoi ce résultat apparaît",
    noRelevantAfterGather:
      "Après deux passes SAIJ, l’IA n’a pas trouvé assez d’arrêts clairement alignés avec votre demande (plafond {asked} pertinents ; obtenus {got}). Reformulez dans le chat.",
    relevanceGatherSummary:
      "{n} résultat(s) jugé(s) pertinent(s) par l’IA (plafond : {target} ; il peut y en avoir moins).",
    dashboardShortcutTitle: "Jurisprudence",
    dashboardShortcutBody:
      "Recherchez arrêts et sommaires par mots-clés, avec un assistant qui précise le sujet et la portée, ou des filtres détaillés. Consultez l’historique et relancez une recherche quand vous voulez.",
    dashboardShortcutCta: "Ouvrir la jurisprudence",
  },

  mev: {
    dashboardShortcutTitle: "MEV — Causes",
    dashboardShortcutBody:
      "Consultez des causes judiciaires avec l’assistant, une recherche rapide en une phrase ou des filtres manuels (tribunal, critères). Les résultats s’affichent en tableau ; l’historique permet de rouvrir des recherches passées.",
    dashboardShortcutCta: "Ouvrir le MEV",
    browsePageTitle: "Guichet virtuel (SCBA)",
    browseNavAria: "Sections de l’écran MEV",
    browseNavAssistant: "Assistant de recherche MEV",
    browseNavQuick: "Recherche rapide",
    browseNavAmbito: "Changer le périmètre MEV",

    browseNavAmbitoActiveTitle:
      "Un périmètre MEV est sélectionné. Ouvrez cet onglet pour le résumé ou le modifier.",
    browseNavHistory: "Historique",
    browseNavHistoryEmpty: "Aucune recherche dans l’historique pour le moment.",
    browseNavAmbitoNotReady:
      "L’accès MEV n’est pas encore configuré. Ouvrez l’onglet « Assistant de recherche MEV » et suivez le chat.",
    browseNavAmbitoChangeAction:
      "Changer le périmètre (recommencer l’assistant)",
    browseNavAmbitoFootnote:
      "Vous choisirez de nouveau tribunal, département et fûros comme sur le portail. La conversation de l’assistant redémarre.",
    browseNavQuickNeedAmbito:
      "Terminez d’abord la configuration du périmètre MEV dans l’onglet « Assistant de recherche MEV », puis utilisez la recherche rapide.",

    browseAiPlaceholder:
      "Ex. : causes avec carátula Pérez à la Première chambre civile du dernier mois",

    searchHistoryViewResults: "Voir les résultats",
    searchHistoryNoResultsStored: "Aucune cause enregistrée pour cette entrée.",
    searchHistoryLegacyBadge: "Pas de copie",
    searchHistorySourceQuick: "Rapide",
    searchHistorySourceManual: "Manuel",
    searchHistorySourceAgent: "Assistant",
    searchHistorySourceDefault: "Liste (config.)",
    gridColAmbito: "Périmètre MEV",
    gridColDepartamento: "Dép. judiciaire",
    gridAmbitoSCJ: "Cour suprême (SCJ)",
    gridAmbitoLPC: "Casación pénale (LPC)",
    gridAmbitoPZ: "Justice de paix (PZ)",
    gridAmbitoCC: "Département judiciaire (CC)",
    gridFueroFamilia: "Fuero familia",
    gridFueroPenal: "Fuero pénal",
    gridDeptoCode: "Dép. {code}",
    searchHistoryDelete: "Supprimer",
    searchHistoryDeleteTitle: "Supprimer de l’historique",
    searchHistoryDeleteConfirm: "Cette entrée sera supprimée. Continuer ?",
    searchHistoryRerun: "Relancer",
    searchDoneTitle: "Recherche terminée",
    newAgentChat: "Nouveau chat avec l’assistant",

    agentChatIntro:
      "Je vous aide à choisir le périmètre MEV (Cour suprême, Casación pénale, Justice de paix, département judiciaire), les fûts, l’organisme et le critère. Par défaut nous affichons jusqu’à 30 causes dans la grille (vous pouvez en demander plus, jusqu’à 200, dans le chat). Ensuite j’exécute la requête.",
    agentCardIntroSetup:
      "D’abord nous configurons l’accès MEV comme sur le portail : choisissez les options proposées. Après validation, je demanderai si nous enregistrons cela dans le navigateur.",
    agentAmbitoSearchModeQuestion:
      "Sur cet écran MEV vous avez la recherche habituelle par juridiction et caractère, ainsi que vos listes enregistrées. Comment configurer l’accès depuis ici ?",
    agentAmbitoSearchModeGeneral:
      "Recherche générale (juridictions et caractère)",
    agentAmbitoSearchModeMisListas: "Dans une liste enregistrée (Mes listes)",
    agentAmbitoSetListQuestion: "Quelle liste utilisons-nous ?",
    agentSaveAmbitoQuestion:
      "Enregistrer cette configuration d’accès dans ce navigateur ? La prochaine fois, la recherche rapide réutilisera le même périmètre avec moins de questions au début.",
    agentSaveAmbitoQuestionWithSavedList:
      "Enregistrer l’accès MEV et la liste choisie (« {list} ») dans ce navigateur ? La prochaine fois vous ouvrirez avec le même périmètre et la même liste ; filtrez par caractère dans la grille ou demandez à l’assistant.",
    agentSaveAmbitoQuestionWithSavedListNoLabel:
      "Enregistrer l’accès MEV avec la liste choisie dans ce navigateur ? La prochaine fois vous ouvrirez avec le même périmètre et la même liste ; filtrez par caractère dans la grille ou demandez à l’assistant.",
    agentSaveAmbitoYes: "Oui, enregistrer",
    agentSaveAmbitoNo: "Non, seulement cette fois",
    agentSaveAmbitoThanks:
      "C’est enregistré dans ce navigateur : la prochaine fois la recherche rapide utilisera le même périmètre. Que cherchez-vous ? Indiquez-le dans ce chat (caractère, juridiction, type de cause, etc.) et nous continuons d’ici.",
    agentSaveAmbitoThanksWithSavedList:
      "C’est fait : périmètre et liste sont enregistrés. La prochaine fois vous arrivez ici directement ; filtrez par caractère dans la liste ou écrivez dans le chat. Que cherchez-vous ?",
    agentNoSaveAmbitoAck:
      "Compris — uniquement pour cette session ; si vous fermez l’onglet vous reconfigurerez le périmètre. Que cherchez-vous ? Écrivez-le dans ce chat et nous continuons.",
    agentChatPlaceholder:
      "Ex. : García à La Plata, tribunal du travail, seulement « en lettre »",
    agentChatSend: "Envoyer",
    agentChatClear: "Réinitialiser",
    agentChatLoading: "Réflexion…",
    agentChatAbortTurn: "Arrêter la recherche",
    quickSearchAbort: "Arrêter la recherche",
    quickSearchLabel: "Recherche rapide (un message)",
    quickSearchHint:
      "Un seul message : l’IA construit le JSON et interroge le MEV. La grille affiche au plus 30 causes (fixe pour la recherche rapide). Pour plus de lignes, utilisez l’assistant et indiquez le nombre souhaité (jusqu’à 200).",
    initialSetupHint:
      "Chargement des organismes pour les filtres manuels et du prompt IA. La liste MEV n’est pas demandée tant que vous n’avez pas lancé une recherche ou le bouton de liste par configuration.",

    loadingListHint: "Récupération des causes depuis le MEV…",
    progress: {},
    agentOpeningGreetingLoading:
      "Génération d’un message d’accueil avec l’IA (quelques secondes)…",
    personalCredsToggleHide: "Masquer",
    personalCredsToggleShow: "Afficher",
    personalCredsTitle: "Votre accès au portail MEV",
    personalCredsIntro:
      "Vous pouvez utiliser votre propre identifiant et mot de passe MEV (mev.scba.gov.ar). S’ils sont enregistrés, les recherches depuis cet écran utiliseront ce compte plutôt que celui configuré dans le module.",
    personalCredsBadgeOn: "Identifiants personnels actifs",
    personalCredsBadgeOff: "Compte du module uniquement",
    personalCredsUsuarioMasked: "Utilisateur enregistré",
    personalCredsPasswordMasked: "Mot de passe",
    personalCredsUsuario: "Utilisateur MEV",
    personalCredsUsuarioPhUpdate:
      "Laisser vide pour ne pas changer l’utilisateur",
    personalCredsPassword: "Mot de passe MEV",
    personalCredsPasswordPhNew: "Mot de passe",
    personalCredsPasswordPhUpdate: "Nouveau mot de passe (optionnel)",
    personalCredsSave: "Enregistrer",
    personalCredsDelete: "Retirer ma connexion",
    personalCredsDeleteTitle: "Retirer les identifiants personnels",
    personalCredsDeleteText:
      "Les requêtes MEV utiliseront uniquement le compte défini dans la configuration du module (s’il existe).",
    personalCredsDeleteConfirm: "Retirer",
    personalCredsFootnote:
      "Le mot de passe est stocké chiffré sur le serveur : il ne peut pas être récupéré ni affiché ici. Seules les deux premières lettres de l’utilisateur sont montrées, avec des points pour le mot de passe.",
    personalCredsMissingTitle: "Champs manquants",
    personalCredsMissingText:
      "Indiquez l’utilisateur et le mot de passe MEV pour enregistrer.",
    personalCredsSaved: "Identifiants enregistrés",
    personalCredsSavedImportText:
      "Votre connexion MEV est prête. Vous pouvez importer toutes vos causes depuis «My Sets» dès maintenant.",
    personalCredsSavedImportButton: "Importer",
    personalCredsSavedLaterButton: "Pas maintenant",
    personalCredsDeleted: "Identifiants personnels retirés",
    importFromMySets: "Importer les causes depuis mes sets",
    importFromMySetsLoading:
      "Lecture des sets et chargement des causes depuis le MEV…",
    importFromMySetsConfirm:
      "La liste de vos sets MEV sera lue et les causes trouvées seront importées. Chaque cause importée enregistrera le nom du set dans le champ type. Cela peut prendre du temps selon le nombre de causes que vous avez dans My Sets.",
    importFromMySetsStep1:
      "Se connecter au portail MEV avec votre utilisateur.",
    importFromMySetsStep2: "Lire tous les sets de «My Sets» et leurs causes.",
    importFromMySetsStep3:
      "Importer chaque cause et assigner le type selon le set.",
    importFromMySetsMayTakeMinutes: "Cela peut prendre quelques minutes.",
    importFromMySetsWorkingTitle: "Import des causes depuis My Sets…",
    importFromMySetsProgress1: "Connexion au MEV et ouverture de My Sets…",
    importFromMySetsProgress2: "Lecture des sets et liste des causes…",
    importFromMySetsProgress3: "Import des causes dans le système…",
    importFromMySetsProgress4: "Attribution du type de cause selon les sets…",
    importFromMySetsProgressCount:
      "Importées {imported}, en erreur {failed}. Traitées {processed} sur {total}…",
    importFromMySetsCancel: "Annuler l’import",
    importFromMySetsCancelledTitle: "Import annulé",
    importFromMySetsCancelledText:
      "L’import depuis My Sets a été annulé. Vous pouvez le relancer quand vous voulez.",
    importFromMySetsConfirmButton: "Importer maintenant",
    importFromMySetsDoneTitle: "Import terminé",
    importFromMySetsNeedLoginTitle: "Connectez-vous d’abord au MEV",
    importFromMySetsNeedLoginText:
      "Pour importer les causes depuis «My Sets», enregistrez d’abord votre utilisateur et mot de passe MEV sur cet écran.",
    importFromMySetsError: "Impossible d’importer depuis vos sets",
    personalCredsError: "L’action n’a pas pu être effectuée",
  },
  twoFactor: {
    title: "Google Authenticator",
    enabled: "Activé : la connexion demande le code du téléphone.",
    disabled: "Désactivé : connexion avec le mot de passe seul.",
    activate: "Activer",
    deactivate: "Désactiver",
    confirm: "Confirmer",
    cancel: "Annuler",
    stepInstall: "Installez Google Authenticator sur votre téléphone.",
    stepScan: "Dans l'app, touchez « + » et scannez ce code QR (ou saisissez la clé à la main).",
    stepConfirm: "Saisissez le code à 6 chiffres affiché par l'app.",
    manualKey: "Clé à saisir à la main",
    codePlaceholder: "Code à 6 chiffres",
    codeRequired: "Saisissez le code Google Authenticator.",
    invalidCode: "Code incorrect.",
    loginHint: "Saisissez le code à 6 chiffres de Google Authenticator.",
    backToPassword: "Retour",
    disableHint: "Pour le désactiver, saisissez un code actuel de l'app.",
    enabledOk: "Google Authenticator activé",
    genericError: "L'opération n'a pas pu aboutir.",
    adminReset: "Retirer 2FA",
    adminResetHint: "Pour qui a perdu son téléphone : il le réactive ensuite depuis Mon profil.",
    adminResetConfirm: "{name} pourra se connecter avec le mot de passe seul jusqu'à réactiver Google Authenticator.",
  },
  telegramAi: {
    menuItem: "Agent IA",
    title: "Agent IA",
    loading: "Chargement…",
    moduleInactive:
      "Activez le module « Agent IA » dans Modules système pour ce tenant.",
    publicWebhookMissing:
      "Impossible de construire l’URL publique du webhook (hôte manquant). Collez la base HTTPS du tunnel dans le champ optionnel lors de l’enregistrement, ou définissez API_PUBLIC_URL / TELEGRAM_AI_PUBLIC_WEBHOOK_BASE sur le serveur.",
    publicBaseFromRequest:
      "L’URL du webhook utilise l’hôte public du même API que cette requête (comme le front). Si Telegram n’atteint pas ce domaine, définissez API_PUBLIC_URL avec la base HTTPS canonique du API.",
    enabled: "Assistant Telegram activé",
    allowlistEmpty:
      "Aucun utilisateur Telegram autorisé. Chaque utilisateur doit renseigner son @ dans Mon profil, puis sélectionnez les utilisateurs ici.",
    allowlistEmptyBilling:
      "Aucun utilisateur Telegram autorisé. Le @ se configure dans Mon profil ; liste dans Facturation → Fonctionnalités système → Agent IA (bot Telegram uniquement, pas le chat support web).",
    allowedUserIds: "Utilisateurs Telegram autorisés",
    allowedUsersPlaceholder: "Rechercher par nom ou e-mail…",
    allowedUsersHint:
      "Bot Telegram uniquement : choisissez qui peut écrire au bot. N’affecte pas le chat support dans l’application. Chacun doit avoir son @ Telegram dans Mon profil.",
    profileUsername: "Nom d’utilisateur Telegram",
    profileUsernamePlaceholder: "utilisateur (sans @)",
    profileUsernameHint:
      "Votre @ Telegram pour que le bot vous reconnaisse. Requis pour figurer sur la liste des utilisateurs Telegram autorisés.",
    noTelegramOnProfile: "pas de @ sur le profil",
    skippedNoTelegramProfile:
      "Certains utilisateurs sélectionnés n’ont pas de @ Telegram sur leur profil et n’ont pas été synchronisés",
    botToken: "Jeton du bot (BotFather)",
    botTokenKeep: "Laisser vide pour conserver le jeton actuel",
    webhookUrl: "URL du webhook",
    webhookUrlPreview: "Aperçu de l’URL du webhook",
    webhookPublicBaseOptional: "Base publique HTTPS (optionnel)",
    webhookPublicBasePlaceholder: "https://xxxx.ngrok-free.app",
    webhookPublicBaseHint:
      "Ex. ngrok vers votre API locale (https, sans slash final). Enregistrez avec « Enregistrer » ; requis si le serveur n’est pas public.",
    save: "Enregistrer",
    registerWebhook: "Enregistrer le webhook chez Telegram",
    registerWebhookNeedToken:
      "Configurez et enregistrez le jeton du bot avant d’enregistrer le webhook.",
    registerWebhookNeedUrl:
      "Indiquez une base HTTPS publique valide ou une API publique ; l’aperçu du webhook ne doit pas être vide.",
    saved: "Réglages enregistrés.",
    registerOk: "Webhook enregistré.",
  },
};
